import React, {Component} from 'react';
import toastr from "toastr";
import http from "../../services/httpService";
import {getCurrentUserId, getJwt, default as authService} from "../../services/authService";
import {Callout, Classes, Intent, MenuItem, Position, Spinner, Switch, Tag, Tooltip} from "@blueprintjs/core";
import countries from "../common/countries.json";
import SmsCounter from "sms-counter";
import {Link} from "react-router-dom";
import {MultiSelect} from "@blueprintjs/select";
import ViberSentModal from "../modals/ViberSentModal";
import PaymentMethodMissingModal from "../modals/PaymentMethodMissingModal";
import PaymentMethodExpiredModal from "../modals/PaymentMethodExpiredModal";
import InputRegular from "../common/InputRegular";
import UpsellModalTailwind from "../modals/UpsellModalTailwind";
import FileUpload from './FileUpload';
import CampaignsTextArea from "../common/CampaignsTextArea";

//ViberBusinessMessage

class Viber extends Component {
    state = {
        jsonCountries: countries,
        messageType: 0,
        characterCount: 0,
        messageContent: '',
        messageHTML: '',

        messagesNumber: 0,
        charsRemaining: 160,
        sendTestMessageModalActive: false,
        rows: 5,
        minRows: 5,
        costEstimate: '',
        costEstimateModalActive: false,
        upgradeModalActive: false,
        listOfNumbers: '',
        numbersArray: [],
        firstMount: true,
        senders: [{text: 'Alphanumeric Sender ID', value: 'Alphanumeric Sender ID'}, {
            text: 'Disabled', value: 'Disabled'
        }],
        selectedSender: 'Alphanumeric Sender ID',
        selectedRecipient: 'All Contacts',
        selectedWhen: 'Immediately',
        selectedTags: [],
        combineOperators: [{
            text: 'AND (Contact must match each criteria specified)', value: 'AND'
        }, {text: 'OR (Contact must match one of the criteria specified)', value: 'OR'}],
        selectedOperator: 'AND (Contact must match each criteria specified )',
        selectedCountries: [],
        selectedDialCodes: [],
        dropdownWidth: '',
        contactsCount: '',
        brand: '',
        selectedTagIds: [],
        loading: false,
        fileLoading: false,
        disabled: false,
        noContacts: false,
        balance: 0,
        contactsError: false,
        personalizeOptions: [],
        freeMessages: '',
        remainingCredits: '',
        freeMessagesUsed: '',
        attemptingMessages: '',
        selectedSourceFull: '',
        viberCredits: '',
        sourcePlan: '',
        update: true,
        modalButtonLabel: '',
        modalButtonLink: '',
        projectPayment: '',
        showContactsCount: false,

        //errors
        //balanceError: false,
        brandError: false,
        personalizationError: false,
        estimateError: false,
        emptyMessageError: false,
        invalidUrlError: false,
        buttonPropertiesError: false,
        combinationError: false,
        excludedContacts: [],
        excludedContactsCount: 0,
        excludedContactsCountryNames: [], //modal settings
        upgradeModalTitle: '',
        upgradeModalContent: '',
        user: this.props.user,
        improperPhones: [],
        paymentMethods: [],
        paymentMethodModal: false,
        paymentMethodExpiredModal: false,
        currentDate: '',
        personalizeParameters: [],
        personalize: 0,
        viberSentModalActive: false,
        currentPlanLimitations: '',
        plansData: this.props.plansData,
        currentPlanData: '',
        country: '',
        listOfEuAbbreviations: ['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'GR', 'HR', 'IT', 'CY', 'LV', 'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'UK', 'GB'],

        numbers: [],
        highlightCostEstimate: false,
        alphanumericId: '',
        selectedSource: this.props.selectedSource,

        //viber custom
        actionButton: 1,
        buttonTextCharacters: 0,
        buttonText: '',
        buttonLink: '',
        messageLifetime: 24,
        fallbackSMSActive: 1,
        smsMessageContent: '',
        smsUpdate: false,
        smsPersonalizeParameters: [],
        smsPersonalize: 0,
        files: [],
        dropzoneHovered: false,
        dropRejectedData: [],
        imageFileUrl: '',
        selectedFileData: null,
        selectedFile: null,

        newBalance: '',
        topUpDisclaimer: false,
        availableCredit: '',
        topUpAmount: '',
        topUpAmountBalance: '',
        initialButtonLink: '',

        cardSoonExpired: false,
        cardExpiringDate: '',
        vatPercent: 0,

        //new states for response

        availableWorkspaceCredit: '',
        newWorkspaceBalance: '',
        topUpBalance: false,
        paymentMessage: '',
        cursorPosition: 0,
        checkErrors: false,

        rerunCampaignData: '',
        rerunFinished: false,
        viberMessageMarkupHeight: 0,

        //fallback SMS parameters
        fallbackSMSContent: '',
        fallbackSMSHTML: '',
        fallbackSMSUpdate: true,
        fallbackSMSPersonalizeParameters: [],
        fallbackSMSPersonalize: '',
        fallbackSMSPersonalizeNotice: '',
    };

    componentDidMount = async () => {
        // //console.log('componentDIdMount user: ', this.state.user)
        // //console.log('componentDIdMount user sources: ', this.state.user.sources.data)
        //console.log('componentDIdMount selected source id: ', this.state.selectedSource)
        //console.log('this.props.location: ', this.props.location)
        const postDataPassed = this.props.location.state ? this.props.location.state.post : '';
        if (postDataPassed && postDataPassed.short_url) {
            this.setState({messageContent: postDataPassed.short_url, messageHTML: postDataPassed.short_url})

        }

        const jsonCountries = countries
        let selectedSourceFull = ''
        let selectedSource = this.state.selectedSource;

        if (this.state.user.sources.data.length > 0) {

            selectedSourceFull = this.state.user.sources.data.filter(source => {
                // //console.log('current source Id : ', source.id)
                // //console.log('selectedSource id :', this.state.selectedSource);
                return source.id.toString() === this.state.selectedSource.toString()

            })
        }
        // console.log('cdm  - selected sourceFull: ', selectedSourceFull)
        let viberPlatform = []
        let viberCredits = 0;
        if (selectedSourceFull[0]) {
            ////console.log('there is selected source full')
            if (selectedSourceFull[0].viber_client) {
                viberCredits = selectedSourceFull[0].viber_client.available_credit.slice(0, -1)


                this.setState({
                    loading: true,
                    topUpAmount: '',
                    topUpAmountBalance: '',
                    topUpDisclaimer: false,
                    newBalance: '',
                    highlightCostEstimate: false
                })


                //DON'T SET STATE VALUE FOR FREE MESSAGES IN COST ESTIMATE
                this.setState({
                    selectedSourceFull: selectedSourceFull,
                    country: selectedSourceFull[0] ? selectedSourceFull[0].default_billing_details ? selectedSourceFull[0].default_billing_details.address.country : '' : '',
                    disabled: true, //emptyMessageError: false,
                    contactsError: false, //balanceError: false,
                    estimateError: false,
                    improperPhones: [],
                    sourcePlan: selectedSourceFull[0] ? selectedSourceFull[0].platforms[0].plan : '',
                    invalidUrlError: false,
                    buttonPropertiesError: false,
                    combinationError: false,
                    checkErrors: false

                });
                // ReactGA.event({
                //     category: 'Click',
                //     action: 'SMS - Estimate Cost ',
                //     userId: getCurrentUserId() //+' - '+getCurrentUserName()
                //     ,
                //     label: '',
                //     nonInteraction: true
                // });

                // let userId = getCurrentUserId();
                ////console.log('free messages start: ', freeMessagesStart);

                //checking if user has contacts

                // console.log(' user has all populated')

                //try {
                this.setState({
                    loading: true
                });
                ////console.log('entering contacts call')
                // //console.log('/api/user/' + userId + '/project/' + selectedSourceFull[0].id + '/imported_contacts/page_size/' + '10' + '?page=' + '1')
                //const contactsResult = await http.get('/api/user/' + userId + '/project/' + selectedSourceFull[0].id + '/imported_contacts/page_size/' + '10' + '?page=' + '1', {headers: {authorization: getJwt()}})
                // //console.log('contactsResult: ', contactsResult);

                // await this.setState({
                //     contactsCount: contactsResult.data.total_count
                // });
                let messageType = 'Text'
                // if (this.state.messageType === 1) {
                //     messageType = 'Test'
                // } else
                //{
                if (this.state.imageFileUrl) {
                    messageType = messageType + '+Image'
                }
                if (this.state.buttonText) {
                    messageType = messageType + '+Button'
                }
                //}
                ////console.log('messageType: ', messageType)

                let activatedCountries = selectedSourceFull[0].viber_client ? selectedSourceFull[0].viber_client.activated_countries : ''
                ////console.log('activatedCountries: ', activatedCountries);

                let activatedDialCodes = [];
                let i = 0
                for (i; i < activatedCountries.length; i++) {

                    // //console.log('i: ', i);
                    // //console.log('activatedCountryCode: ', activatedCountries[i])

                    let newFullCountry = this.state.jsonCountries.find(country => {
                        try {
                            return country.code === activatedCountries[i]
                        } catch (e) {
                            return ''
                        }

                    })

                    // //console.log('newActivatedCountryFull: ', newFullCountry)

                    if (newFullCountry) {
                        //    //console.log('newActivatedCountryFullDialCode: ', newFullCountry.dial_code)
                        activatedDialCodes.push(newFullCountry.dial_code)
                    }
                }

                // //console.log('activatedDialCodes: ', activatedDialCodes)


                // if user has contacts -> getting cost estimate


                ////console.log('there are contacts')

                // let selectedTagIds = [];
                // const selectedTags = this.state.selectedTags;
                //
                //
                // this.state.selectedTags.map(tag => {
                //     selectedTagIds = [...selectedTagIds, tag.id]
                // });
                // this.setState({
                //     selectedTagIds: selectedTagIds
                // })

                //rerun handle
                let selectedTags = []
                let selectedTagIds = []
                let allTags = this.props.tags
                let buttonLink = ''
                let buttonText = ''
                let imageFileUrl = ''
                if (this.props.location.state) {
                    if (this.props.location.state.id) {
                        let rerunData = this.props.location.state
                        console.info('cdm - this.props.location.state: ', rerunData)

                        let existingTag = ''
                        if (rerunData.tags[0] !== 'Everyone') {

                            let rerunTags = rerunData.tags
                            console.info('cdm - rerunTags: ', rerunTags)
                            // console.info('cdm - message_html: ', rerunData.message_html)
                            if (rerunTags) {
                                rerunTags.map((el, i) => {
                                    //console.info('entered loop')

                                    existingTag = allTags.filter(tag => {
                                        return tag.tag === el
                                    })


                                    //console.info('existingTag: ', existingTag)
                                    // let filteredTag = existingTag.filter(function (el) {
                                    //     return el != null;
                                    // });
                                    // console.log('filteredTag: ', filteredTag)
                                    if (existingTag.length !== 0) {
                                        selectedTags.push(existingTag[0])
                                        selectedTagIds.push(existingTag[0].id)
                                    }

                                })
                            } else {
                                selectedTags = []
                                selectedTagIds = []
                            }
                            await this.setState({
                                messageHTML: rerunData.message_html, selectedRecipient: 'Use Segments',

                            })
                            // console.log('cdm 1 - selectedRecipient: ', this.state.selectedRecipient)
                        }
                        if (rerunData.type === 'Text+Button') {
                            buttonLink = rerunData.message.components[1].button.callback
                            buttonText = rerunData.message.components[1].button.caption
                        }
                        if (rerunData.type === 'Text+Image+Button') {
                            buttonLink = rerunData.message.components[2].button.callback
                            buttonText = rerunData.message.components[2].button.caption
                            imageFileUrl = rerunData.message.components[1].image.url
                        }

                        this.setState({
                            selectedTags,
                            selectedTagIds,
                            rerunCampaignData: rerunData,
                            buttonLink,
                            buttonText,
                            imageFileUrl,
                            rerunFinished: true
                        })
                        this.handleMessageUpdate(this.props.location.state.message.components[0].text)
                    }
                }


                let data = {};

                let selectedSourceData = this.props.user && this.props.user.sources && this.props.user.sources.data.length ? this.props.user.sources.data.find(source => source.id.toString() === selectedSource.toString()) : '';

                // let selectedFeedSharedData = this.props.user && this.props.user.feeds_shared && this.props.user.feeds_shared.length ?
                // this.props.user.feeds_shared.find(feed => feed.project_id.toString() === selectedSource.toString()) : ''

                // let alphanumericId = selectedSourceData && selectedSourceData.alphanumeric_id ? selectedSourceData.alphanumeric_id :
                //     selectedFeedSharedData && selectedFeedSharedData.alphanumeric_id ? selectedFeedSharedData.alphanumeric_id : '';

                let alphanumericId = selectedSourceData.alphanumeric_id

                if (selectedSourceFull[0] && selectedSourceFull[0].viber_client) {
                    alphanumericId = selectedSourceFull[0].viber_client.brand_name
                }

                if (alphanumericId !== this.state.alphanumericId) {
                    this.setState({alphanumericId})
                }

                // console.log('cdm - selected tag ids: ', selectedTagIds)
                // console.log('this.state.selectedRecipient: ', this.state.selectedRecipient)
                if (this.state.selectedRecipient === 'Add Manually') {
                    //console.log('entered add manually data')

                    data = {
                        "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                        "message_type": messageType,
                        "message_way": "twoway",
                        "button_caption": this.state.buttonText,
                        "button_url": this.state.buttonLink,
                        "image_url": this.state.imageFileUrl,
                        "message": this.state.messageContent !== '' ? this.state.messageContent : '&nbsp',//to calculate estimate based on message length-number of characters
                        "from": this.state.alphanumericId,
                        "provider": "tyntec",
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": 0,//use tags or not for sending
                        "tag_ids": [],//list of tag ids (existing tags client previously created)
                        "manual_contacts": 1,//use manually pasted contacts (phone numbers)
                        "phones": this.state.numbersArray,//send as an array of phones
                        "country_codes": activatedDialCodes,//which country codes to include in sending-sends only to contacts who match this criteria
                        "country_isos": activatedCountries,
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize

                    }
                } else if (this.state.selectedRecipient === 'All Contacts') {
                    // console.log('entered all contacts data')
                    data = {

                        "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                        "message_type": messageType,
                        "message_way": "twoway",
                        "button_caption": this.state.buttonText,
                        "button_url": this.state.buttonLink,
                        "image_url": this.state.imageFileUrl,
                        "message": this.state.messageContent !== '' ? this.state.messageContent : '&nbsp',//to calculate estimate based on message length-number of characters
                        "from": this.state.alphanumericId,
                        "provider": "tyntec",
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": 0,//use tags or not for sending
                        "tag_ids": [],//list of tag ids (existing tags client previously created)
                        "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                        "phones": [],//send as an array of phones
                        "country_codes": activatedDialCodes,//which country codes to include in sending-sends only to contacts who match this criteria
                        "country_isos": activatedCountries,
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize

                    }
                } else {
                    // console.log('entered use segments data')
                    //
                    // //console.log('segments data - activatedCountries: ', activatedCountries);
                    // //console.log('segments data - activatedDialCodes: ', activatedDialCodes);
                    // //console.log('this.state.selectedCountries: ', this.state.selectedCountries)
                    // //console.log('this.state.selectedDialCodes: ', this.state.selectedDialCodes)

                    let countriesArray = []
                    if (this.state.selectedCountries.length === 0) {
                        // //console.log('selected countries state empty')
                        countriesArray = activatedCountries
                    } else {
                        // //console.log('selected countries state not empty')
                        let i = 0;
                        for (i; i < this.state.selectedCountries.length; i++) {
                            // //console.log('i: ', i);
                            // //console.log('selected country: ', this.state.selectedCountries[i]);
                            countriesArray.push(this.state.selectedCountries[i].code);
                        }
                    }

                    // //console.log('countriesArray: ', countriesArray)

                    let dialCodesArray = []

                    if (this.state.selectedDialCodes.length === 0) {
                        // //console.log('selected dial codes state empty')
                        dialCodesArray = activatedDialCodes
                    } else {
                        // //console.log('selected dial codes state not empty')

                        dialCodesArray = this.state.selectedDialCodes
                    }

                    // //console.log('dialCodesArray: ', dialCodesArray)

                    data = {
                        "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                        "message_type": messageType,
                        "tag_segmentation": this.state.selectedTags.length > 0 ? 1 : 0,//use tags or not for sending
                        "tag_ids": selectedTagIds,//list of tag ids (existing tags client previously created)
                        "message_way": "twoway",
                        "button_caption": this.state.buttonText,
                        "button_url": this.state.buttonLink,
                        "image_url": this.state.imageFileUrl,
                        "message": this.state.messageContent !== '' ? this.state.messageContent : '&nbsp',//to calculate estimate based on message length-number of characters
                        "from": this.state.alphanumericId,
                        "provider": "tyntec",
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                        "phones": [],//send as an array of phones
                        "country_isos": countriesArray,   //which country codes to include in sending-sends only to contacts who match this criteria
                        "country_codes": dialCodesArray, //which country dial codes to include in sending-sends only to contacts who match this criteria
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize

                    }
                }

                //console.log('cdm - cost estimated data: ', data);
                let result = ''
                try {

                    //console.log('enteredSendingCostEstimate call')
                    //console.log('cdm - /api/user/' + this.state.user.id + '/project/' + this.state.selectedSource + '/viber_cost_estimate');
                    result = await http.post('/api/user/' + this.state.user.id + '/project/' + this.state.selectedSource + '/viber_cost_estimate', data, {
                        headers: {
                            authorization: authService.getJwt()
                        }
                    });

                    //cost estimate result
                    // console.info('cdm -getCostEstimate result: ', result)
                    // console.info('there is result')

                    this.setState({
                        loading: false
                    })
                    if (result.data.message) {
                        if (result.data.message !== 'empty message') {
                            toastr.error('Error Code #12019: ' + result.data.message);
                        } else {
                            //todo: define error for empty message after cost estimate
                        }
                        this.setState({
                            loading: false
                        })
                    } else {

                        let improperPhones = result.data.improper_phones ? result.data.improper_phones[0] === null ? [] : result.data.improper_phones : []

                        let newBalance = Number(result.data.viber_credit_remaining)

                        //console.log('costEstimate - newBalance - viber credit remaining: ', newBalance)

                        let availableCredit = result.data['initial_credit_remaining'] === 0 ? '0.00' : parseFloat(Number(result.data["initial_credit_remaining"].substr(result.data["initial_credit_remaining"].length - 1) === '$' ? result.data["initial_credit_remaining"].slice(0, -1) : result.data["initial_credit_remaining"]))


                        let availableWorkspaceCredit = result.data.project_balance_initial
                        let newWorkspaceBalance = result.data.workspace_credits_remaining
                        // console.log('getCostEstimate - availableCredit: ', availableCredit)

                        // let costEstimateValue = result.data.error ? result.data.error : result.data.estimate
                        // //console.log('costEstimateValue: ', costEstimateValue)
                        // let costEstimateValueDecimals = this.countDecimals(costEstimateValue)
                        //
                        // //console.log('costEstimateValueDecimals: ', costEstimateValueDecimals)
                        let zeroContacts = result.data.count && this.state.noContacts;
                        //console.log('costEstimate - zeroContacts: ', zeroContacts)
                        let excludedContacts = []
                        let excludedContactsCount = 0
                        let excludedContactsCountryNames = []
                        if ((result.data.excluded_contacts.length === 1 && result.data.excluded_contacts[0].country_code === null) || result.data.excluded_contacts.length === 0) {
                            excludedContacts = []
                            excludedContactsCount = 0

                        } else {
                            // console.log('result.data.excluded_contacts: ', result.data.excluded_contacts)
                            //console.info('cdu - result.data.excluded_contacts: ', result.data.excluded_contacts)
                            excludedContacts = result.data.excluded_contacts
                            //console.log('cdm - excludedContacts: ', result.data.excluded_contacts)
                            excludedContactsCount = excludedContacts.map(excludedContact => {
                                //console.log('excludedContactTotalForCountry: ', excludedContact.total_for_country)
                                // console.log('excludedContact: ', excludedContact)
                                jsonCountries.find(country => {
                                    if (country.code === excludedContact.country_code) {
                                        //console.log('country.name: ', country['name'])
                                        excludedContactsCountryNames.push(country['name'])
                                    }
                                })
                                //console.log('cdm - excludedContactsCountryNames: ', excludedContactsCountryNames)
                                return excludedContactsCount + excludedContact.total_for_country
                            })

                        }
                        //handling sum of
                        //console.info('cdm - excludedContactsCount before: ', excludedContactsCount)
                        excludedContactsCount = excludedContactsCount ? excludedContactsCount.reduce(function (pv, cv) {
                            return pv + cv;
                        }, 0) : 0

                        // console.info('cdm - excludedContactsCountryNames: ', excludedContactsCountryNames)
                        // console.info('cdm - excludedContactsCount: ', excludedContactsCount)

                        if (zeroContacts) {
                            this.setState({
                                noContacts: true,
                                loading: false,
                                disabled: false,
                                costEstimate: '$0',
                                vatPercent: 0,
                                excludedContacts: [],
                                excludedContactsCount: 0,
                                excludedContactsCountryNames: []
                            })
                        } else {
                            this.setState({
                                noContacts: false,
                                contactsCount: result.data.count,
                                contactsError: zeroContacts && result.data.count === 0,
                                excludedContacts: excludedContacts,
                                excludedContactsCount,
                                excludedContactsCountryNames,
                                showContactsCount: true, //freeMessages: result.data.error ? result.data.error : result.data.free_messages_remaining,
                                loading: false,
                                disabled: this.state.currentPlanLimitations ? this.state.selectedSourceFull[0].plan.additional_features.tags_segmentation === 0 && this.state.selectedRecipient === 'Use Segments' : true,
                                estimateError: !!result.data.error,
                                costEstimate: result.data.error ? result.data.error : result.data.estimate === 0 ? 0 : result.data.estimate < 0.01 ? Number(result.data.estimate).toFixed(4) : Number(result.data.estimate).toFixed(2),
                                attemptingMessages: result.data.error ? result.data.total_subscribers : '',
                                remainingCredits: result.data.error ? result.data.remaining_credits : '',
                                update: false,
                                improperPhones,
                                newBalance,
                                availableCredit,
                                availableWorkspaceCredit,
                                newWorkspaceBalance,
                                vatPercent: result?.data?.vat_percent ?? 0,
                                paymentMessage: result.data.payment_message
                            })
                        }

                        // if (this.state.firstMount === false) {
                        //     await this.setState({
                        //             firstMount: true,
                        //         }
                        //     )
                        // }

                        if (parseFloat(this.state.costEstimate) > 0 && parseFloat(this.state.costEstimate) >


                            (this.state.availableCredit)) {
                            // //console.log('topUpShouldBeThere')
                            let topUpAmount = result.data.top_up_amount
                            let topUpAmountBalance = result.data.top_up_amount_balance
                            //console.log('topUpAmountBalance: ', topUpAmountBalance)
                            this.setState({
                                topUpAmount: topUpAmount,
                                topUpDisclaimer: topUpAmountBalance !== 0 && topUpAmountBalance <= 15,
                                topUpAmountBalance: topUpAmountBalance === 0 ? 0 : topUpAmountBalance < 15 ? 15 : topUpAmountBalance,

                            })
                        }
                    }
                    this.setState({
                        loading: false
                    })


                } catch (e) {
                    //   //console.log('getCostEstimate error: ', e)
                    toastr.error('Error Code #12020: Something went wrong... Please refresh and try again.');

                    this.setState({
                        loading: false, disabled: false
                    })
                }

            }
            this.setState({
                sourcePlan: selectedSourceFull[0].plan.plan_id,
                selectedSourceFull,
                currentPlanLimitations: selectedSourceFull[0].plan,
                viberCredits: Number(viberCredits)
            })
        }


        // if (this.state.user.feeds_shared.length > 0) {
        // if (selectedSourceFull.length === 0) {
        //     selectedSourceFull = await this.state.user.feeds_shared.filter(
        //         source => {
        //             // //console.log('current source Id : ', source.id)
        //             // //console.log('selectedSource id :', this.state.selectedSource);
        //             return source.project_id.toString() === this.state.selectedSource.toString()
        //
        //         }
        //     )
        // }

        //this doesnt event exists here >
        ////console.log('componentDidMount selectedSourceFull: ', selectedSourceFull)


        let today = new Date();
        let dateFormat = [today.getFullYear(), today.getMonth() + 1, //  today.getDate()
        ].join('-')


        // + ' ' +
        // [today.getHours(),
        //     today.getMinutes(),
        //     today.getSeconds()].join(':');
        ////console.log('current date: ', dateFormat);

        this.setState({
            currentDate: dateFormat
        })

        //  ReactGA.pageview(window.location.pathname + window.location.search);
        //this.getUserBilling()


        //this.getNumbers()

        let viberBalance = ''

        if (selectedSourceFull[0]) {
            if (selectedSourceFull[0].viber_client) {
                if (selectedSourceFull[0].viber_client.available_credit) {
                    viberBalance = selectedSourceFull[0].viber_client.available_credit
                    this.setState({
                        balance: viberBalance !== '' ? viberBalance : this.state.balance
                    })
                }
            }
        }

        //console.log('CDM - viber balance: ', viberBalance)
        this.setState({
            selectedSource, loading: false
            //balance: viberBalance !== '' ? viberBalance : this.state.balance
        })
        this.calculateMarkupScreenHeight()
    };
    handleViberFallbackMessage = (message) => {
        this.setState({
            update: true, messageContent: message
        })
        this.getCursorPosition()
    }
    calculateMarkupScreenHeight = async () => {
        if (document.querySelector('.viber-message-markup')) {
            let viberMessageMarkupHeight = document.querySelector('.viber-message-markup').offsetHeight
            this.setState({
                viberMessageMarkupHeight
            })
        }
    }
    cleanHTMLMessage = (html) => {
        let cleanMessage = String(html)
        //console.log('Content editable html: ', html)

        //handling Tags cleaning
        if (cleanMessage.includes('&nbsp;')) {
            cleanMessage = cleanMessage.replace(/&nbsp;/g, ' ')
        }
        if (cleanMessage.includes('&lt')) {
            cleanMessage = cleanMessage.replace(/&lt;/g, ' ')
        }
        if (cleanMessage.includes('&gt')) {
            cleanMessage = cleanMessage.replace(/&gt;/g, ' ')
        }
        if (cleanMessage.includes('<br>')) {
            cleanMessage = cleanMessage.replace(/<br>/g, '\n')
        }
        if (cleanMessage.includes('<div class="delete-personalization-tag" contenteditable="false">×</div>')) {
            cleanMessage = cleanMessage.replace(/<div class="delete-personalization-tag" contenteditable="false">×<\/div>/g, '')
        }
        if (cleanMessage.includes('</span>')) {
            cleanMessage = cleanMessage.replace(/<\/span>/g, '')
        }

        if (cleanMessage.includes('</label>')) {
            cleanMessage = cleanMessage.replace(/<\/label>/g, '')
        }
        if (cleanMessage.includes('<span class="tag noselect" contenteditable="false">first_name')) {
            //console.log('there is first name tag')
            cleanMessage = cleanMessage.replace(/<span class="tag noselect" contenteditable="false">first_name/g, '{first_name}')
        }
        if (cleanMessage.includes('<span class="tag noselect" contenteditable="false">last_name')) {
            //console.log('there is a last name tag')
            cleanMessage = cleanMessage.replace(/<span class="tag noselect" contenteditable="false">last_name/g, '{last_name}')
        }
        if (cleanMessage.includes('<span class="tag noselect" contenteditable="false">full_name')) {
            cleanMessage = cleanMessage.replace(/<span class="tag noselect" contenteditable="false">full_name:/g, '{full_name}')
        }
        if (cleanMessage.includes('<label class="tag trackable-link" contenteditable="false">')) {
            cleanMessage = cleanMessage.replace(/<label class="tag trackable-link" contenteditable="false">/g, '')
        }
        if (cleanMessage.includes('</div><div>')) {
            cleanMessage = cleanMessage.replace(/<\/div><div>/g, '\n')
        }
        if (cleanMessage.includes('<div>')) {
            cleanMessage = cleanMessage.replace(/<div>/g, '\n')
        }

        if (cleanMessage.includes('</div>')) {
            cleanMessage = cleanMessage.replace(/<\/div>/g, "\n")
        }
        if (cleanMessage.includes('<span style="letter-spacing: 0;">')) {
            cleanMessage = cleanMessage.replace(/<span style="letter-spacing: 0;">/g, "")
        }
        if (cleanMessage.includes('«span style= letter-spacing: Opx;"›')) {
            cleanMessage = cleanMessage.replace(/«span style= letter-spacing: Opx;"›/g, "")
        }
        //cleaning all span tags in the end
        if (cleanMessage.match(/<span[^>]*>/g)) {
            cleanMessage = cleanMessage.replace(/<span[^>]*>/g, '')
        }
        //cleaning all font open tags in the end
        if (cleanMessage.includes('</font>')) {
            cleanMessage = cleanMessage.replace(/<\/font>/g, '')
        }
        if (cleanMessage.match(/<font[^>]*>/g)) {
            cleanMessage = cleanMessage.replace(/<font[^>]*>/g, '')
        }

        if (cleanMessage.match(/<.+?>/g)) {
            cleanMessage = cleanMessage.replace(/<.+?>/g, '')
        }
        //console.log('slice: ', this.state.html.slice(-4))

        // if (cleanMessage.includes('\n\n')) {
        //     cleanMessage = cleanMessage.replaceAll('\n\n', "\n")
        // }
        //cleanMessage = cleanMessage.replaceAll(/<[^>]*>?/gm, '')

        //console.log('ContentEditable clean message: ', cleanMessage)

        return cleanMessage

    }

    componentDidUpdate = async () => {

        if (this.state.selectedSource !== this.props.selectedSource) {
            //console.log('selectedSource componentDidUpdate')
            let excludedContacts = []
            let excludedContactsCount = 0
            let excludedContactsCountryNames = []
            const jsonCountries = countries

            //this.getNumbers();
            ////console.log('entered component did update')

            this.setState({
                selectedSource: this.props.selectedSource,

                excludedContacts, excludedContactsCount, excludedContactsCountryNames
            })
            let selectedSource = this.props.selectedSource;
            let selectedSourceFull = await this.state.user.sources.data.filter(source => {
                // //console.log('current source Id : ', source.id)
                // //console.log('selectedSource id :', selectedSource);

                return source.id.toString() === selectedSource.toString()

            })
            //console.log('CDU - selected source full: ', selectedSourceFull)
            //cost estimation start
            this.setState({
                topUpBalance: false
            })
            let userId = getCurrentUserId();

            let viberPlatform = []
            ////console.log('selectedSource full: ', selectedSourceFull)
            if (selectedSourceFull[0]) {
                viberPlatform = selectedSourceFull[0].platforms.filter(platform => platform.platform === 'vib')
                ////console.log('sms platform :', viberPlatform);

            }
            if (selectedSourceFull[0] && selectedSourceFull[0].viber_client) {

                //console.log('get cost estimate started')
                ////console.log('countries: ', this.state.jsonCountries)

                await this.setState({
                    loading: true, topUpAmount: '', topUpDisclaimer: false, newBalance: '', highlightCostEstimate: false
                })

                // let selectedSourceFull = this.state.selectedSourceFull
                //
                // let viberPlatform = []
                // ////console.log('selectedSource full: ', selectedSourceFull)
                // if (selectedSourceFull[0]) {
                //     viberPlatform = selectedSourceFull[0].platforms.filter(
                //         platform => platform.platform === 'sms'
                //     )
                //     ////console.log('sms platform :', viberPlatform);
                //
                // }

                //DON'T SET STATE VALUE FOR FREE MESSAGES IN COST ESTIMATE
                await this.setState({
                    selectedSourceFull: selectedSourceFull,
                    currentPlanLimitations: selectedSourceFull[0].plan,
                    country: selectedSourceFull[0] ? selectedSourceFull[0].default_billing_details ? selectedSourceFull[0].default_billing_details.address.country : '' : '',
                    disabled: true, //emptyMessageError: false,
                    contactsError: false, //balanceError: false,
                    estimateError: false,
                    improperPhones: [],
                    sourcePlan: selectedSourceFull[0] ? selectedSourceFull[0].platforms[0].plan : '',
                    invalidUrlError: false,
                    buttonPropertiesError: false,
                    combinationError: false,
                    checkErrors: false

                });
                // ReactGA.event({
                //     category: 'Click',
                //     action: 'SMS - Estimate Cost ',
                //     userId: getCurrentUserId() //+' - '+getCurrentUserName()
                //     ,
                //     label: '',
                //     nonInteraction: true
                // });

                // let userId = getCurrentUserId();
                ////console.log('free messages start: ', freeMessagesStart);

                //checking if user has contacts
                if (selectedSource !== '' && selectedSourceFull[0] && viberPlatform !== [] && viberPlatform[0]) {

                    //console.log(' user has all populated')

                    //try {
                    await this.setState({
                        loading: true
                    });
                    ////console.log('entering contacts call')
                    // //console.log('/api/user/' + userId + '/project/' + selectedSourceFull[0].id + '/imported_contacts/page_size/' + '10' + '?page=' + '1')
                    //const contactsResult = await http.get('/api/user/' + userId + '/project/' + selectedSourceFull[0].id + '/imported_contacts/page_size/' + '10' + '?page=' + '1', {headers: {authorization: getJwt()}})
                    // //console.log('contactsResult: ', contactsResult);

                    // await this.setState({
                    //     contactsCount: contactsResult.data.total_count
                    // });
                    let messageType = 'Text'
                    // if (this.state.messageType === 1) {
                    //     messageType = 'Test'
                    // } else
                    //{
                    if (this.state.imageFileUrl) {
                        messageType = messageType + '+Image'
                    }
                    if (this.state.buttonText) {
                        messageType = messageType + '+Button'
                    }
                    //}
                    ////console.log('messageType: ', messageType)

                    let activatedCountries = selectedSourceFull[0].viber_client ? selectedSourceFull[0].viber_client.activated_countries : ''
                    //console.log('activatedCountries: ', activatedCountries);

                    let activatedDialCodes = [];
                    let i = 0
                    for (i; i < activatedCountries.length; i++) {

                        // //console.log('i: ', i);
                        // //console.log('activatedCountryCode: ', activatedCountries[i])

                        let newFullCountry = await countries.find(country => {
                            //try {
                            return country.code === activatedCountries[i]
                            // } catch (e) {
                            //     return ''
                            // }

                        })

                        //console.log('newActivatedCountryFull: ', newFullCountry)

                        if (newFullCountry) {
                            //    //console.log('newActivatedCountryFullDialCode: ', newFullCountry.dial_code)
                            activatedDialCodes.push(newFullCountry.dial_code)
                        }
                    }

                    // //console.log('activatedDialCodes: ', activatedDialCodes)


                    // if user has contacts -> getting cost estimate


                    ////console.log('there are contacts')

                    let selectedTagIds = [];
                    const selectedTags = this.state.selectedTags;


                    this.state.selectedTags.map(tag => {
                        selectedTagIds = [...selectedTagIds, tag.id]
                    });
                    this.setState({
                        selectedTagIds: selectedTagIds
                    })
                    let data = {};

                    // console.log('cdu - selectedTagIds: ', selectedTagIds)
                    if (this.state.selectedRecipient === 'Add Manually') {
                        //console.log('entered add manually data')

                        data = {
                            "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                            "message_type": messageType,
                            "message_way": "twoway",
                            "button_caption": this.state.buttonText,
                            "button_url": this.state.buttonLink,
                            "image_url": this.state.imageFileUrl,
                            "message": this.state.messageContent !== '' ? this.state.messageContent : '&nbsp',//to calculate estimate based on message length-number of characters
                            "from": selectedSourceFull[0].alphanumeric_id,
                            "provider": "tyntec",
                            "model_type": "all",//fixed to “all” currently
                            "model_gender": "all",//fixed to “all” currently
                            "tag_segmentation": 0,//use tags or not for sending
                            "tag_ids": [],//list of tag ids (existing tags client previously created)
                            "manual_contacts": 1,//use manually pasted contacts (phone numbers)
                            "phones": this.state.numbersArray,//send as an array of phones
                            "country_codes": activatedDialCodes,//which country codes to include in sending-sends only to contacts who match this criteria
                            "country_isos": activatedCountries,
                            "personalize_parameters": this.state.personalizeParameters,
                            "personalize": this.state.personalize

                        }
                    } else if (this.state.selectedRecipient === 'All Contacts') {
                        // //console.log('entered all contacts data')
                        data = {
                            "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                            "message_type": messageType,
                            "message_way": "twoway",
                            "button_caption": this.state.buttonText,
                            "button_url": this.state.buttonLink,
                            "image_url": this.state.imageFileUrl,
                            "message": this.state.messageContent !== '' ? this.state.messageContent : '&nbsp',//to calculate estimate based on message length-number of characters
                            "from": selectedSourceFull[0].alphanumeric_id,
                            "provider": "tyntec",
                            "model_type": "all",//fixed to “all” currently
                            "model_gender": "all",//fixed to “all” currently
                            "tag_segmentation": 0,//use tags or not for sending
                            "tag_ids": [],//list of tag ids (existing tags client previously created)
                            "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                            "phones": [],//send as an array of phones
                            "country_codes": activatedDialCodes,//which country codes to include in sending-sends only to contacts who match this criteria
                            "country_isos": activatedCountries,
                            "personalize_parameters": this.state.personalizeParameters,
                            "personalize": this.state.personalize
                        }

                    } else {
                        // //console.log('entered use segments data')
                        //
                        // //console.log('segments data - activatedCountries: ', activatedCountries);
                        // //console.log('segments data - activatedDialCodes: ', activatedDialCodes);
                        // //console.log('this.state.selectedCountries: ', this.state.selectedCountries)
                        // //console.log('this.state.selectedDialCodes: ', this.state.selectedDialCodes)

                        let countriesArray = []
                        if (this.state.selectedCountries.length === 0) {
                            // //console.log('selected countries state empty')
                            countriesArray = activatedCountries
                        } else {
                            // //console.log('selected countries state not empty')
                            let i = 0;
                            for (i; i < this.state.selectedCountries.length; i++) {
                                // //console.log('i: ', i);
                                // //console.log('selected country: ', this.state.selectedCountries[i]);
                                countriesArray.push(this.state.selectedCountries[i].code);
                            }
                        }

                        // //console.log('countriesArray: ', countriesArray)

                        let dialCodesArray = []

                        if (this.state.selectedDialCodes.length === 0) {
                            // //console.log('selected dial codes state empty')
                            dialCodesArray = activatedDialCodes
                        } else {
                            // //console.log('selected dial codes state not empty')

                            dialCodesArray = this.state.selectedDialCodes
                        }

                        // //console.log('dialCodesArray: ', dialCodesArray)

                        data = {
                            "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                            "message_type": messageType,
                            "tag_segmentation": this.state.selectedTags.length > 0 ? 1 : 0,//use tags or not for sending
                            "tag_ids": selectedTagIds,//list of tag ids (existing tags client previously created)
                            "message_way": "twoway",
                            "button_caption": this.state.buttonText,
                            "button_url": this.state.buttonLink,
                            "image_url": this.state.imageFileUrl,
                            "message": this.state.messageContent !== '' ? this.state.messageContent : '&nbsp',//to calculate estimate based on message length-number of characters
                            "from": selectedSourceFull[0].alphanumeric_id,
                            "provider": "tyntec",
                            "model_type": "all",//fixed to “all” currently
                            "model_gender": "all",//fixed to “all” currently
                            "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                            "phones": [],//send as an array of phones
                            "country_isos": countriesArray,   //which country codes to include in sending-sends only to contacts who match this criteria
                            "country_codes": dialCodesArray, //which country dial codes to include in sending-sends only to contacts who match this criteria
                            "personalize_parameters": this.state.personalizeParameters,
                            "personalize": this.state.personalize

                        }
                    }

                    //console.log('cdu - cost estimated data: ', data);
                    let errorDetected = 0
                    let result = ''
                    try {

                        //console.log('enteredSendingCostEstimate call')
                        //console.log('cdu - /api/user/' + userId + '/project/' + this.state.selectedSource + '/viber_cost_estimate');
                        result = await http.post('/api/user/' + userId + '/project/' + this.state.selectedSource + '/viber_cost_estimate', data, {
                            headers: {
                                authorization: authService.getJwt()
                            }
                        });

                        //cost estimate result
                        //console.log('cdu - getCostEstimate result: ', result)


                    } catch (e) {
                        errorDetected = 1
                        //   //console.log('getCostEstimate error: ', e)
                        toastr.error('Error Code #12021: Something went wrong... Please refresh and try again.');

                        this.setState({
                            loading: false, disabled: false
                        })
                    }
                    if (!errorDetected && result) {

                        if (result.data.message) {
                            if (result.data.message !== 'empty message') {
                                toastr.error('Error Code #12022: ' + result.data.message);
                            } else {
                                //todo: define error for empty message after cost estimate
                            }
                            this.setState({
                                loading: false
                            })
                        } else {

                            let improperPhones = result.data.improper_phones ? result.data.improper_phones[0] === null ? [] : result.data.improper_phones : []

                            let newBalance = await Number(result.data.viber_credit_remaining)

                            //console.log('costEstimate - newBalance - viber credit remaining: ', newBalance)

                            let availableCredit = result.data['initial_credit_remaining'] === 0 ? '0.00' : parseFloat(Number(result.data["initial_credit_remaining"].substr(result.data["initial_credit_remaining"].length - 1) === '$' ? result.data["initial_credit_remaining"].slice(0, -1) : result.data["initial_credit_remaining"]))

                            let availableWorkspaceCredit = result.data.project_balance_initial
                            let newWorkspaceBalance = result.data.workspace_credits_remaining
                            // console.log('getCostEstimate - availableCredit: ', availableCredit)

                            // let costEstimateValue = result.data.error ? result.data.error : result.data.estimate
                            // //console.log('costEstimateValue: ', costEstimateValue)
                            // let costEstimateValueDecimals = this.countDecimals(costEstimateValue)
                            //
                            // //console.log('costEstimateValueDecimals: ', costEstimateValueDecimals)
                            let zeroContacts = result.data.count && this.state.noContacts;
                            //console.log('costEstimate - zeroContacts: ', zeroContacts)
                            let excludedContacts = []
                            let excludedContactsCount = 0
                            let excludedContactsCountryNames = []
                            if ((result.data.excluded_contacts.length === 1 && result.data.excluded_contacts[0].country_code === null) || result.data.excluded_contacts.length === 0) {
                                excludedContacts = []
                                excludedContactsCount = 0

                            } else {
                                //console.info('cdu - result.data.excluded_contacts: ', result.data.excluded_contacts)
                                excludedContacts = result.data.excluded_contacts
                                //console.log('cdu - excluded contacts: ', excludedContacts)
                                excludedContactsCount = excludedContacts.map(excludedContact => {
                                    //console.log('excludedContactTotalForCountry: ', excludedContact.total_for_country)
                                    // console.log('excludedContact: ', excludedContact)
                                    jsonCountries.find(country => {
                                        if (country.code === excludedContact.country_code) {
                                            //console.log('country.name: ', country['name'])
                                            excludedContactsCountryNames.push(country['name'])
                                        }
                                    })
                                    //console.log('cdu - excludedContactsCountryNames: ', excludedContactsCountryNames)
                                    return excludedContactsCount + excludedContact.total_for_country
                                })

                            }
                            //handling sum of

                            excludedContactsCount = excludedContactsCount ? excludedContactsCount.reduce(function (pv, cv) {
                                return pv + cv;
                            }, 0) : 0

                            //console.info('cdu - excludedContactsCountryNames: ', excludedContactsCountryNames)
                            //console.info('cdu - excludedContactsCount: ', excludedContactsCount)

                            // console.log('excludedContactsCount: ', excludedContactsCount)

                            if (zeroContacts) {
                                this.setState({
                                    noContacts: true,
                                    loading: false,
                                    disabled: false,
                                    costEstimate: '$0',
                                    vatPercent: 0,
                                    excludedContactsCount: 0,
                                    excludedContacts: [],
                                    excludedContactsCountryNames: []
                                })
                            } else {
                                await this.setState({
                                    noContacts: false,
                                    contactsCount: result.data.count,
                                    contactsError: zeroContacts && result.data.count === 0,
                                    excludedContacts: excludedContacts,
                                    excludedContactsCount,
                                    excludedContactsCountryNames,
                                    showContactsCount: true, //freeMessages: result.data.error ? result.data.error : result.data.free_messages_remaining,
                                    loading: false,
                                    disabled: this.state.currentPlanLimitations ? this.state.selectedSourceFull[0].plan.additional_features.tags_segmentation === 0 && this.state.selectedRecipient === 'Use Segments' : true,
                                    estimateError: !!result.data.error,
                                    costEstimate: result.data.error ? result.data.error : result.data.estimate === 0 ? 0 : result.data.estimate < 0.01 ? Number(result.data.estimate).toFixed(4) : Number(result.data.estimate).toFixed(2),
                                    attemptingMessages: result.data.error ? result.data.total_subscribers : '',
                                    remainingCredits: result.data.error ? result.data.remaining_credits : '',
                                    update: false,
                                    improperPhones,
                                    newBalance,
                                    availableCredit,
                                    availableWorkspaceCredit,
                                    newWorkspaceBalance,
                                    vatPercent: result?.data?.vat_percent ?? 0,
                                    paymentMessage: result.data.payment_message
                                })
                            }

                            // if (this.state.firstMount === false) {
                            //     await this.setState({
                            //             firstMount: true,
                            //         }
                            //     )
                            // }

                            if (parseFloat(this.state.costEstimate) > 0 && parseFloat(this.state.costEstimate) >


                                (this.state.availableCredit)) {
                                // //console.log('topUpShouldBeThere')
                                let topUpAmount = result.data.top_up_amount
                                let topUpAmountBalance = result.data.top_up_amount_balance
                                //console.log('topUpAmountBalance: ', topUpAmountBalance)
                                this.setState({
                                    topUpAmount: topUpAmount,
                                    topUpDisclaimer: topUpAmountBalance !== 0 && topUpAmountBalance <= 15,
                                    topUpAmountBalance: topUpAmountBalance === 0 ? 0 : topUpAmountBalance < 15 ? 15 : topUpAmountBalance,

                                })
                            }
                        }
                    }


                    // } catch (e) {
                    //     ////console.log('getContactsError: ', e)
                    //
                    //     toastr.error('Something went wrong... Please try again');
                    //     this.setState({
                    //         loading: false,
                    //         disabled: false
                    //     })
                    // }
                }
            } else {
                toastr.error("Error Code #12022: There is no Viber client activated for this workspace!")
                //console.log('there is no viber client, do nothing')
            }

            // console.log('cdu selectedSourceFull: ', selectedSourceFull)
            const postDataPassed = this.props.location.state ? this.props.location.state.post : '';
            if (postDataPassed && postDataPassed.short_url && !this.state.buttonLink) {
                this.setState({initialButtonLink: postDataPassed.short_url})
            }

            let viberBalance = null;
            if (selectedSourceFull[0]) {
                if (selectedSourceFull[0].viber_client) {
                    if (selectedSourceFull[0].viber_client.available_credit) {
                        viberBalance = selectedSourceFull[0].viber_client.available_credit.slice(0, -1)
                        this.setState({
                            balance: viberBalance !== '' ? Number(viberBalance) : this.state.balance
                        })
                    }
                }
            }

            this.setState({
                selectedSource,
                selectedSourceFull,
                currentPlanLimitations: selectedSourceFull[0].plan,
                sourcePlan: selectedSourceFull[0] ? selectedSourceFull[0].platforms[0].plan : '',

            })
            //await this.getUserBilling()


            // this.setState({
            //     update: true
            // })

            ////console.log('selectedSourceFull: ', selectedSourceFull);
            if (selectedSourceFull[0] && selectedSourceFull[0].viber_client) {
                let i = 0
                let selectedSourceViberCountries = selectedSourceFull[0].viber_client.activated_countries
                //console.log('componentDidUpdate - selectedSourceViberCountries: ', selectedSourceViberCountries)

                let activatedCountries = []
                for (i; i < selectedSourceViberCountries.length; i++) {
                    let activatedCountry = this.state.jsonCountries.find(country => {
                        if (country && country.code === selectedSourceViberCountries[i]) {
                            return country
                        }

                    })
                    activatedCountries.push(activatedCountry)
                }
                //console.log('activatedCountries: ', activatedCountries)
                this.setState({
                    jsonCountries: activatedCountries
                })

            }

            // //console.log('selectedSource :', selectedSource)
            // //console.log('viber - feeds shared data: ', this.props.user)

            let selectedSourceData = this.props.user && this.props.user.sources && this.props.user.sources.data.length ? this.props.user.sources.data.find(source => source.id.toString() === selectedSource.toString()) : '';

            // let selectedFeedSharedData = this.props.user && this.props.user.feeds_shared && this.props.user.feeds_shared.length ?
            //     this.props.user.feeds_shared.find(feed =>
            //         feed.project_id.toString() ===
            //         selectedSource.toStr§ing())
            //     : ''


            // let alphanumericId = selectedSourceData && selectedSourceData.alphanumeric_id ? selectedSourceData.alphanumeric_id :
            //     selectedFeedSharedData && selectedFeedSharedData.alphanumeric_id ? selectedFeedSharedData.alphanumeric_id : '';

            let alphanumericId = selectedSourceData.alphanumeric_id
            if (selectedSourceFull[0] && selectedSourceFull[0].viber_client) {
                alphanumericId = await selectedSourceFull[0].viber_client.brand_name
            }
            if (alphanumericId !== this.state.alphanumericId) {
                await this.setState({alphanumericId})
            }

            //console.log('cdu - selectedSourceFull: ', selectedSourceFull)
        }

        // if (this.state.currentPlanLimitations !== this.props.currentPlanLimitations) {
        //     //console.log('planLimitations componentDidUpdate')
        //     await this.setState({
        //         currentPlanLimitations: this.props.currentPlanLimitations,
        //
        //     })
        //
        //     // //console.log('sms component did update - current plan limitations: ', this.props.currentPlanLimitations)
        // }
    }

    validURL = (str) => {
        // //console.log('str :', str)
        if (str !== '') {
            // //console.log('str is not empty')
            let pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
            return !!pattern.test(str);
        } else {
            // //console.log('str is empty')
            return true
        }
    }

    changeMessageType = async (messageType) => {
        if (messageType === 0) {
            await this.setState({
                messageType
            })
        } else {
            await this.setState({
                files: [],
                dropzoneHovered: false,
                dropRejectedData: [],
                imageFileUrl: '',
                selectedFileData: null,
                selectedFile: null,
                buttonText: '',
                buttonLink: '',
                buttonTextCharacters: 0,
                messageType
            })
        }
        if (this.state.messageContent) {
            await this.getCostEstimate()
        }
    }

    onFileUploadStart = () => {
        this.setState({fileLoaderActive: true});
    }

    onFileUploadEnd = (url, file) => {
        // if (url.substr(url.length - 4) === '.pdf') {
        //     toastr.success("File successfully uploaded!")
        // } else {
        //     toastr.success("Image file successfully uploaded!");
        // }
        this.setState({
            files: [file],
            imageFileUrl: url,
            loaded: 0,
            selectedFile: null,
            selectedFileData: null,
            spinnerActive: false,
            dropRejectedData: []
        });
        this.calculateMarkupScreenHeight()
    }

    onUploadProgressChange = (progress) => {
        // this.setState({loaded: Math.round(progress * 100)});
        // console.log('onUploadProgressChange: ', progress, this.state.loaded)
    }
    onDrop = async (acceptedFiles) => {

        await this.setState({files: []})

        // //console.log('accepted files onDrop: ', acceptedFiles.length)
        // //console.log('drop rejected data: ', this.state.dropRejectedData)

        this.setState({files: acceptedFiles})
        if (acceptedFiles.length !== 0) {
            await this.uploadImageFile(acceptedFiles)
        } else {
            this.setState({selectedFile: ''})
        }
        //await this.parseImageFile(acceptedFiles);

    };

    uploadImageFile = (acceptedFiles) => {

        const reader = new FileReader();
        reader.addEventListener('load', () => {
            this.setState({
                selectedFileData: reader.result
            })
            this.fileUploadHandler(reader);
        }, false);

        // //console.log('accepted files upload: ', acceptedFiles)

        reader.readAsDataURL(acceptedFiles[0]);
        this.setState({selectedFile: acceptedFiles[0]});

    }

    fileUploadHandler = async (fileData) => {
        // const upload_URL = "https://api.emitto.io/api/files/"+getCurrentUserId();
        if (this.state.files && this.state.files.length > 0 && fileData.result) {
            let file = this.state.files[0]
            let formData = await {
                file: fileData.result,
                category: "viber_preview_image",
                name: file.name,
                size: file.size,
                type: file.type
            };

            try {
                await this.setState({spinnerActive: true})
                await http.post('api/files/' + getCurrentUserId(), formData, {headers: {authorization: getJwt()}}, {
                    onUploadProgress: progressEvent => {
                        this.setState({loaded: Math.round(progressEvent.loaded / progressEvent.total * 100)});
                    }
                }).then(res => {
                    // //console.log('upload res: ', res)
                    // //console.log('upload res: ', res.data.viber_preview_image)
                    if (res.data.viber_preview_image.substr(res.data.viber_preview_image.length - 4) === '.pdf') {
                        toastr.success("File successfully uploaded!")
                    } else {
                        toastr.success("Image file successfully uploaded!");
                    }
                    this.setState({
                        imageFileUrl: res.data.viber_preview_image,
                        loaded: 0,
                        selectedFile: null,
                        selectedFileData: null,
                        spinnerActive: false,
                        dropRejectedData: []

                    });
                    this.calculateMarkupScreenHeight()
                });
            } catch (ex) {
                this.setState({spinnerActive: false})
                if (ex.response && ex.response.status === 404) toastr.error("Error Code #12023: Unsuccessful upload, please try again later.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error('Error Code #12024: ' + ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }
    };

    removeViberImage = async () => {
        await this.setState({
            files: [], dropRejectedData: [], imageFileUrl: ''
        });
    }

    handleUploadSuccess = () => {
        // //console.log('upload success entered')
        let imageName = /[^/]*$/.exec(this.state.imageFileUrl)[0]
        if (imageName.length > 30) {
            imageName = imageName.slice(0, 30) + '...'
        }
        //this.setState({fileLoading: true})
        return (<div className="success-container">
                <div className="image-container">
                    {this.state.imageFileUrl === '' ? <span
                        className='fa fa-spin fa-spinner'></span> : this.state.imageFileUrl.substr(this.state.imageFileUrl.length - 4) === '.pdf' ?
                        <img src="/img/pdf.png" alt="pdf document"/> :
                        <img src={this.state.imageFileUrl} alt={imageName}/>}
                    <p>{imageName}</p>
                </div>
                <span onClick={this.removeViberImage} className="fas fa-times"></span>

            </div>

        )
        //this.setState({fileLoading: false})
    }

    handleUploadError = () => {
        // //console.log('upload error entered')
        return (<div className="error-container">
            <p>
                {this.state.dropRejectedData.length > 1 ? 'You can upload only one  file!' : // this.state.dropRejectedData.type !== 'png' ||   this.state.dropRejectedData.type !== 'jpeg' ||  this.state.dropRejectedData.type !== 'jpg' ||  this.state.dropRejectedData.type !== 'pdf'
                    this.state.dropRejectedData.length === 1 ? 'Invalid file type! Only .png,. jpeg, .jpg or .pdf files are supported' : 'File upload was unsuccessful, please try again!'}
            </p>
            {/*{this.setState(*/}
            {/*    {dropRejectedData: []}*/}
            {/*)}*/}
        </div>)

    }

    getUserBilling = async () => {

        ////console.log('this.state.selectedSource: ', this.state.selectedSource)
        ////console.log('currentUserId: ', getCurrentUserId())
        ////console.log('user: ', this.props.user)

        if (this.state.selectedSource !== '') {
            try {
                ////console.log('billing call: ', '/api/user/' + getCurrentUserId() + '/project/' + this.state.selectedSource + '/customers/get_payment_methods_project')
                const billingResult = await http.get('/api/user/' + getCurrentUserId() + '/project/' + this.state.selectedSource + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                //console.log('billing call result: ', billingResult)
                let defaultPayment = billingResult.data.project_payment_methods.find(payment => payment.project_default === 1);
                this.setState({
                    projectPayment: billingResult.data.project_payment_methods[0] ? defaultPayment : '',
                })
            } catch (e) {
                this.setState({
                    loading: false, disabled: false
                })
                toastr.error('Error Code #12025: Something went wrong... Please try again.')
            }
            if (this.state.projectPayment) {
                //console.log('currentDate: ', new Date())
                //console.log('projectPaymentDate: ', this.state.projectPayment.ends_at)

                let expiringDate = this.state.projectPayment.ends_at.slice(0, -12)
                //console.log('expiring date: ', expiringDate)
                let todayDate = new Date()
                //console.log('today date: ', todayDate)
                let year = todayDate.getFullYear().toString()
                let month = todayDate.getMonth() + 1
                //console.log('month: ', month + 1)
                if (month < 10) {
                    month = '0' + month.toString()
                } else {
                    month = month.toString()
                }
                let currentDate = year + '-' + month

                //console.log('currentDate: ', currentDate)


                this.setState({
                    cardSoonExpired: currentDate === expiringDate, cardExpiringDate: expiringDate
                })

            }
        }
    }


    openUpgradeModal = () => {
        // console.log('modal opening')
        this.setState({
            upgradeModalActive: true,
            upgradeModalTitle: 'Segmentation is not available on your current plan.',
            upgradeModalContent: `<p>Check out the plans and features below and choose one that suits your needs.<br>
                Our team is available from the chat if you need any assistance.</p>`

        })
    }

    handleBrand = (brand) => {
        ////console.log('brand: ', brand)
        let letterNumber = /^[0-9a-zA-Z ]+$/;
        if (brand.match(letterNumber) || brand === '') {
            this.setState({
                brand, brandError: false
            })
        } else {
            this.setState({
                brandError: true
            });
        }

    }

    handleMessageUpdate = (message) => {

        //console.log('message: ', message)
        let personalizationNotice = false
        let personalizeParameters = []

        if (message.includes('{first_name}')) {
            personalizationNotice = true
            if (!personalizeParameters.includes("first_name")) {
                personalizeParameters = [...personalizeParameters, "first_name"]
            }
        }
        if (message.includes('{last_name}')) {
            personalizationNotice = true

            if (!personalizeParameters.includes("last_name")) {
                personalizeParameters = [...personalizeParameters, "last_name"]
            }
        }
        if (message.includes('{full_name}')) {
            personalizationNotice = true

            if (!personalizeParameters.includes("full_name")) {
                personalizeParameters = [...personalizeParameters, "full_name"]
            }
        }

        this.setState({
            messageContent: message,
            update: true,
            personalizeParameters,
            personalize: personalizeParameters.length > 0 ? 1 : 0,
            personalizationNotice
        })
        this.calculateMarkupScreenHeight()
    }
    updateCursorPosition = (places) => {
        this.setState({
            cursorPosition: this.state.cursorPosition + places
        })
    }


    countPhoneNumbers = () => {
        let count = this.state.listOfNumbers.split(',').length
        this.setState({contactsCount: count})
    }

    triggerActionButton = () => {
        this.setState({
            buttonText: '', buttonLink: '', actionButton: !this.state.actionButton
        })
    }

    triggerFallbackSms = () => {
        this.setState({

            fallbackSMSActive: !this.state.fallbackSMSActive
        })
    }
    updateCostEstimate = async () => {
        if (this.state.messageContent) {
            this.getCostEstimate()
        } else {
            await this.setState({
                emptyMessageError: true, checkErrors: true
            })

        }
        this.setState({
            firstMount: false
        })
    }

    getCostEstimate = async () => {
        const jsonCountries = countries
        //console.log('entered cost estimate')
        this.setState({
            topUpBalance: false
        })
        let userId = getCurrentUserId();
        let selectedSourceFull = this.state.selectedSourceFull

        let viberPlatform = []
        ////console.log('selectedSource full: ', selectedSourceFull)
        if (selectedSourceFull[0]) {
            viberPlatform = selectedSourceFull[0].platforms.filter(platform => platform.platform === 'sms')
            ////console.log('sms platform :', viberPlatform);

        }
        if (this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].viber_client) {

            //console.log('get cost estimate started')
            ////console.log('countries: ', this.state.jsonCountries)

            await this.setState({
                loading: true, topUpAmount: '', topUpDisclaimer: false, newBalance: '', highlightCostEstimate: false
            })

            // let selectedSourceFull = this.state.selectedSourceFull
            //
            // let viberPlatform = []
            // ////console.log('selectedSource full: ', selectedSourceFull)
            // if (selectedSourceFull[0]) {
            //     viberPlatform = selectedSourceFull[0].platforms.filter(
            //         platform => platform.platform === 'sms'
            //     )
            //     ////console.log('sms platform :', viberPlatform);
            //
            // }

            //DONT SET STATE VALUE FOR FREE MESSAGES IN COST ESTIMATE
            await this.setState({
                selectedSourceFull: selectedSourceFull,
                country: selectedSourceFull[0] ? selectedSourceFull[0].default_billing_details ? selectedSourceFull[0].default_billing_details.address.country : '' : '',
                disabled: true, //emptyMessageError: false,
                contactsError: false, //balanceError: false,
                estimateError: false,
                improperPhones: [],
                sourcePlan: selectedSourceFull[0] ? selectedSourceFull[0].platforms[0].plan : '',
                invalidUrlError: false,
                buttonPropertiesError: false,
                combinationError: false,
                checkErrors: false

            });
            // ReactGA.event({
            //     category: 'Click',
            //     action: 'SMS - Estimate Cost ',
            //     userId: getCurrentUserId() //+' - '+getCurrentUserName()
            //     ,
            //     label: '',
            //     nonInteraction: true
            // });

            // let userId = getCurrentUserId();
            ////console.log('free messages start: ', freeMessagesStart);

            //checking if user has contacts
            if (this.state.selectedSource !== '' && selectedSourceFull[0] && viberPlatform !== [] && viberPlatform[0]) {

                //console.log(' user has all populated')

                //try {
                await this.setState({
                    loading: true
                });
                ////console.log('entering contacts call')
                // //console.log('/api/user/' + userId + '/project/' + selectedSourceFull[0].id + '/imported_contacts/page_size/' + '10' + '?page=' + '1')
                //const contactsResult = await http.get('/api/user/' + userId + '/project/' + selectedSourceFull[0].id + '/imported_contacts/page_size/' + '10' + '?page=' + '1', {headers: {authorization: getJwt()}})
                // //console.log('contactsResult: ', contactsResult);

                // await this.setState({
                //     contactsCount: contactsResult.data.total_count
                // });
                let messageType = 'Text'
                // if (this.state.messageType === 1) {
                //     messageType = 'Test'
                // } else
                //{
                if (this.state.imageFileUrl) {
                    messageType = messageType + '+Image'
                }
                if (this.state.buttonText) {
                    messageType = messageType + '+Button'
                }
                //}
                ////console.log('messageType: ', messageType)

                let activatedCountries = this.state.selectedSourceFull[0].viber_client ? this.state.selectedSourceFull[0].viber_client.activated_countries : ''
                ////console.log('activatedCountries: ', activatedCountries);

                let activatedDialCodes = [];
                let i = 0
                for (i; i < activatedCountries.length; i++) {

                    // //console.log('i: ', i);
                    // //console.log('activatedCountryCode: ', activatedCountries[i])

                    let newFullCountry = await this.state.jsonCountries.find(country => {
                        try {
                            return country.code === activatedCountries[i]
                        } catch (e) {
                            return ''
                        }

                    })

                    // //console.log('newActivatedCountryFull: ', newFullCountry)

                    if (newFullCountry) {
                        //    //console.log('newActivatedCountryFullDialCode: ', newFullCountry.dial_code)
                        activatedDialCodes.push(newFullCountry.dial_code)
                    }
                }

                // //console.log('activatedDialCodes: ', activatedDialCodes)


                // if user has contacts -> getting cost estimate


                ////console.log('there are contacts')

                let selectedTagIds = [];
                const selectedTags = this.state.selectedTags;


                this.state.selectedTags.map(tag => {
                    selectedTagIds = [...selectedTagIds, tag.id]
                });
                this.setState({
                    selectedTagIds: selectedTagIds
                })
                let data = {};


                if (this.state.selectedRecipient === 'Add Manually') {
                    //console.log('entered add manually data')

                    data = {
                        "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                        "message_type": messageType,
                        "message_way": "twoway",
                        "button_caption": this.state.buttonText,
                        "button_url": this.state.buttonLink,
                        "image_url": this.state.imageFileUrl,
                        "message": this.state.messageContent !== '' ? this.state.messageContent : '&nbsp',//to calculate estimate based on message length-number of characters
                        "from": this.state.alphanumericId,
                        "provider": "tyntec",
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": 0,//use tags or not for sending
                        "tag_ids": [],//list of tag ids (existing tags client previously created)
                        "manual_contacts": 1,//use manually pasted contacts (phone numbers)
                        "phones": this.state.numbersArray,//send as an array of phones
                        "country_codes": activatedDialCodes,//which country codes to include in sending-sends only to contacts who match this criteria
                        "country_isos": activatedCountries,
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize,
                        "message_html": this.state.messageHTML


                    }
                } else if (this.state.selectedRecipient === 'All Contacts') {
                    // //console.log('entered all contacts data')
                    data = {

                        "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                        "message_type": messageType,
                        "message_way": "twoway",
                        "button_caption": this.state.buttonText,
                        "button_url": this.state.buttonLink,
                        "image_url": this.state.imageFileUrl,
                        "message": this.state.messageContent !== '' ? this.state.messageContent : '&nbsp',//to calculate estimate based on message length-number of characters
                        "from": this.state.alphanumericId,
                        "provider": "tyntec",
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": 0,//use tags or not for sending
                        "tag_ids": [],//list of tag ids (existing tags client previously created)
                        "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                        "phones": [],//send as an array of phones
                        "country_codes": activatedDialCodes,//which country codes to include in sending-sends only to contacts who match this criteria
                        "country_isos": activatedCountries,
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize,
                        "message_html": this.state.messageHTML


                    }
                } else {
                    // //console.log('entered use segments data')
                    //
                    // //console.log('segments data - activatedCountries: ', activatedCountries);
                    // //console.log('segments data - activatedDialCodes: ', activatedDialCodes);
                    // //console.log('this.state.selectedCountries: ', this.state.selectedCountries)
                    // //console.log('this.state.selectedDialCodes: ', this.state.selectedDialCodes)

                    let countriesArray = []
                    if (this.state.selectedCountries.length === 0) {
                        // //console.log('selected countries state empty')
                        countriesArray = activatedCountries
                    } else {
                        // //console.log('selected countries state not empty')
                        let i = 0;
                        for (i; i < this.state.selectedCountries.length; i++) {
                            // //console.log('i: ', i);
                            // //console.log('selected country: ', this.state.selectedCountries[i]);
                            countriesArray.push(this.state.selectedCountries[i].code);
                        }
                    }

                    // //console.log('countriesArray: ', countriesArray)

                    let dialCodesArray = []

                    if (this.state.selectedDialCodes.length === 0) {
                        // //console.log('selected dial codes state empty')
                        dialCodesArray = activatedDialCodes
                    } else {
                        // //console.log('selected dial codes state not empty')

                        dialCodesArray = this.state.selectedDialCodes
                    }

                    // //console.log('dialCodesArray: ', dialCodesArray)

                    data = {
                        "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                        "message_type": messageType,
                        "tag_segmentation": this.state.selectedTags.length > 0 ? 1 : 0,//use tags or not for sending
                        "tag_ids": selectedTagIds,//list of tag ids (existing tags client previously created)
                        "message_way": "twoway",
                        "button_caption": this.state.buttonText,
                        "button_url": this.state.buttonLink,
                        "image_url": this.state.imageFileUrl,
                        "message": this.state.messageContent !== '' ? this.state.messageContent : '&nbsp',//to calculate estimate based on message length-number of characters
                        "from": this.state.alphanumericId,
                        "provider": "tyntec",
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                        "phones": [],//send as an array of phones
                        "country_isos": countriesArray,   //which country codes to include in sending-sends only to contacts who match this criteria
                        "country_codes": dialCodesArray, //which country dial codes to include in sending-sends only to contacts who match this criteria
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize,
                        "message_html": this.state.messageHTML


                    }
                }

                //console.log('cost estimated data: ', data);
                let result = ''
                try {

                    //console.log('enteredSendingCostEstimate call')
                    //console.log('/api/user/' + userId + '/project/' + selectedSourceFull[0].id + '/cost_estimate');
                    result = await http.post('/api/user/' + userId + '/project/' + selectedSourceFull[0].id + '/viber_cost_estimate', data, {
                        headers: {
                            authorization: authService.getJwt()
                        }
                    });

                    //cost estimate result
                    // console.log('getCostEstimate result: ', result)

                } catch (e) {
                    //   //console.log('getCostEstimate error: ', e)
                    toastr.error('Error Code #12026: Something went wrong... Please refresh and try again.3');

                    this.setState({
                        loading: false, disabled: false
                    })
                }
                if (result !== '' && result) {

                    if (result.data.message) {
                        if (result.data.message !== 'empty message') {
                            toastr.error('Error Code #12027: ' + result.data.message);
                        } else {
                            //todo: define error for empty message after cost estimate
                        }
                        this.setState({
                            loading: false
                        })
                    } else {

                        let improperPhones = result.data.improper_phones ? result.data.improper_phones[0] === null ? [] : result.data.improper_phones : []

                        let newBalance = await Number(result.data.viber_credit_remaining)

                        //console.log('costEstimate - newBalance - viber credit remaining: ', newBalance)

                        let availableCredit = result.data["initial_credit_remaining"] === 0 ? 0 : parseFloat(Number(result.data["initial_credit_remaining"].substr(result.data["initial_credit_remaining"].length - 1) === '$' ? result.data["initial_credit_remaining"].slice(0, -1) : result.data["initial_credit_remaining"]))


                        let availableWorkspaceCredit = result.data.project_balance_initial
                        let newWorkspaceBalance = result.data.workspace_credits_remaining
                        // console.log('getCostEstimate - availableCredit: ', availableCredit)

                        // let costEstimateValue = result.data.error ? result.data.error : result.data.estimate
                        // //console.log('costEstimateValue: ', costEstimateValue)
                        // let costEstimateValueDecimals = this.countDecimals(costEstimateValue)
                        //
                        // //console.log('costEstimateValueDecimals: ', costEstimateValueDecimals)
                        let zeroContacts = result.data.count && this.state.noContacts;
                        //console.log('costEstimate - zeroContacts: ', zeroContacts)
                        let excludedContacts = result.data.excluded_contacts
                        let excludedContactsCount = 0
                        let excludedContactsCountryNames = []
                        if ((result.data.excluded_contacts.length === 1 && result.data.excluded_contacts[0].country_code === null) || result.data.excluded_contacts.length === 0) {
                            excludedContacts = []
                            excludedContactsCount = 0
                        } else {
                            // let i = 0
                            // for (i; i++; i < result.data.excluded_contacts) {
                            //     console.log('result.data.excluded_contacts[i].total_for_country: ', result.data.excluded_contacts[i].total_for_country)
                            //     excludedContactsCount = excludedContactsCount + result.data.excluded_contacts[i].total_for_country
                            // }

                            excludedContactsCount = excludedContacts.map(excludedContact => {
                                //console.log('excludedContactTotalForCountry: ', excludedContact.total_for_country)
                                // console.log('excludedContact: ', excludedContact)
                                jsonCountries.find(country => {
                                    if (country.code === excludedContact.country_code) {
                                        //console.log('country.name: ', country['name'])
                                        excludedContactsCountryNames.push(country['name'])
                                    }
                                })
                                //console.log('cdm - excludedContactsCountryNames: ', excludedContactsCountryNames)
                                return excludedContactsCount + excludedContact.total_for_country
                            })


                            //console.info('excludedContactsCountryNames: ', excludedContactsCountryNames)

                        }

                        //handling sum of

                        excludedContactsCount = excludedContactsCount ? excludedContactsCount.reduce(function (pv, cv) {
                            return pv + cv;
                        }, 0) : 0
                        // console.info('gce - excludedContactsCountryNames: ', excludedContactsCountryNames)
                        // console.info('gce - excludedContactsCount: ', excludedContactsCount)
                        if (zeroContacts) {
                            this.setState({
                                noContacts: true,
                                loading: false,
                                disabled: false,
                                costEstimate: '$0',
                                vatPercent: 0,
                                excludedContactsCount: 0,
                                excludedContactsCountryNames: []
                            })
                        } else {
                            await this.setState({
                                noContacts: false,
                                contactsCount: result.data.count,
                                contactsError: zeroContacts && result.data.count === 0,
                                excludedContacts: excludedContacts,
                                excludedContactsCount,
                                excludedContactsCountryNames: excludedContactsCountryNames,
                                showContactsCount: true, //freeMessages: result.data.error ? result.data.error : result.data.free_messages_remaining,
                                loading: false,
                                disabled: this.state.currentPlanLimitations ? this.state.selectedSourceFull[0].plan.additional_features.tags_segmentation === 0 && this.state.selectedRecipient === 'Use Segments' : true,
                                estimateError: !!result.data.error,
                                costEstimate: result.data.error ? result.data.error : result.data.estimate === 0 ? 0 : result.data.estimate < 0.01 ? Number(result.data.estimate).toFixed(4) : Number(result.data.estimate).toFixed(2),
                                attemptingMessages: result.data.error ? result.data.total_subscribers : '',
                                remainingCredits: result.data.error ? result.data.remaining_credits : '',
                                update: false,
                                improperPhones,
                                newBalance,
                                availableCredit,
                                availableWorkspaceCredit,
                                newWorkspaceBalance,
                                vatPercent: result?.data?.vat_percent ?? 0,
                                paymentMessage: result.data.payment_message
                            })
                        }

                        // if (this.state.firstMount === false) {
                        //     await this.setState({
                        //             firstMount: true,
                        //         }
                        //     )
                        // }

                        if (parseFloat(this.state.costEstimate) > 0 && parseFloat(this.state.costEstimate) >


                            (this.state.availableCredit)) {
                            // //console.log('topUpShouldBeThere')
                            let topUpAmount = result.data.top_up_amount
                            let topUpAmountBalance = result.data.top_up_amount_balance
                            //console.log('topUpAmountBalance: ', topUpAmountBalance)
                            this.setState({
                                topUpAmount: topUpAmount,
                                topUpDisclaimer: topUpAmountBalance !== 0 && topUpAmountBalance <= 15,
                                topUpAmountBalance: topUpAmountBalance === 0 ? 0 : topUpAmountBalance < 15 ? 15 : topUpAmountBalance,

                            })
                        }
                    }
                } else {
                    toastr.error('Error Code #12028: Something went wrong... Please refresh and try again.3');
                }

                // } catch (e) {
                //     ////console.log('getContactsError: ', e)
                //
                //     toastr.error('Something went wrong... Please try again');
                //     this.setState({
                //         loading: false,
                //         disabled: false
                //     })
                // }
            }
        } else {
            toastr
            .error("There is no Viber client activated for this workspace!")
            //console.log('there is no viber client, do nothing')
        }

    }

    getParameters = (str) => {
        let results = [], re = /{{([^}]+)}}/g, text;

        while (text = re.exec(str)) {
            results.push(text[1]);
        }
        return results;
    };

//CHECKING BALANCE AND CREDIT CARDS

    startCampaign = async (type) => {
        //console.log('entered startCampaign')
        // console.log('const estimate number: ', Number(this.state.costEstimate));
        if (this.state.update === false) {

            if (this.state.costEstimate !== '' && this.state.costEstimate !== "0.00") {
                // console.log('cost estimate is not null')

                // if (this.state.projectPayment === "") {
                //     // console.log('there is no payment method')
                //     if (this.state.balance !== null) {
                //         // console.log('balance is not null')
                //         if (this.state.balance > Number(this.state.costEstimate)) {
                //             // console.log('balance is bigger than cost estimate')
                //             await this.sendViber()
                //
                //         } else {
                //             // console.log('balance is not bigger than cost estimate')
                //             await this.setState({
                //                 paymentMethodModal: true
                //             })
                //         }
                //     } else {
                //         if (this.state.viberCredits !== 0 && this.state.viberCredits !== '') {
                //             await this.sendViber()
                //         } else {
                //             await this.setState({
                //                 paymentMethodModal: true
                //             })
                //         }
                //     }
                //
                // } else
                //{
                // let cardExpiring = this.state.projectPayment.ends_at.substring(0, this.state.projectPayment.ends_at.length - 12)
                // ////console.log('cardExpiring: ', cardExpiring);
                // let date1 = new Date(this.state.currentDate.replace(/-/g, '/'));
                // let date2 = new Date(cardExpiring.replace(/-/g, '/'));
                // let cardExpired = date1 > date2
                ////console.log('card expired: ', cardExpired)
                ////console.log('payment method added')
                ////console.log('currentDate: ', this.state.currentDate)
                ////console.log('expiration date: ', cardExpiring)

                //console.log('payment is not missing')

                // let date1 = new Date(this.state.currentDate.replace(/-/g, '/'));
                // let date2 = new Date(this.state.projectPayment.ends_at.replace(/-/g, '/'));

                //console.log('currentDate: ', this.state.currentDate)
                //console.log('currentDate: ', this.state.projectPayment.ends_at)


                // let cardExpired = date1 > date2
                ////console.log('cardExpired: ', cardExpired);
                //if (cardExpired) {
                //     if (this.state.balance !== null) {
                //         //console.log('payment expired - balance is not null')
                //         if (this.state.balance > Number(this.state.costEstimate)) {
                //             //console.log('payment expired - balance is bigger than cost estimate')
                //             await this.sendViber()
                //
                //         } else {
                //             //console.log('payment expired - balance is not bigger than cost estimate')
                //             await this.setState({
                //                 paymentMethodExpiredModal: true
                //             })
                //         }
                //     }
                // } else {
                await this.sendViber(type)
                // }
                // }
            } else {
                // ////console.log('cost estimate is  null')
                // ////console.log('currentDate: ', this.state.currentDate)
                // ////console.log('expiration date: ', this.state.projectPayment.ends_at)
                //
                // let date1 = new Date(this.state.currentDate.replace(/-/g, '/'));
                // let date2 = new Date(this.state.projectPayment.ends_at.replace(/-/g, '/'));
                //
                // let cardExpired = date1 > date2
                // ////console.log('cardExpired: ', cardExpired);
                // if (cardExpired) {
                //     this.setState({
                //         paymentMethodExpiredModal: true
                //     })
                // } else {
                await this.sendViber(type)
                //}
            }
        } else {
            await this.setState({
                highlightCostEstimate: true
            })
            toastr.error('Error Code #12029: Please update estimated cost before starting campaign!')
        }
    };

    sendViber = async (type) => {
        // console.log('type: ', type)
        // //console.log('enteredSendViber')
        //await this.getCostEstimate()
        // let insufficientBalance = false;//this.state.balance < this.state.costEstimate;
        let zeroContacts = this.state.contactsCount === 0 || this.state.noContacts;
        let personalizationError = false;
        let personalizeOptions = this.state.personalizeOptions
        let improperPhonesError = this.state.improperPhones
        //let emptyMessageError = this.state.emptyMessageError
        //emptyMessageError = this.state.messageContent === '';

        let i = 0;
        if (this.state.messageContent.includes("{{")) {

            let result = this.getParameters(this.state.messageContent);
            ////console.log('parameters result :', result);

            for (i; i < result.length; i++) {
                if (result[i] !== 'first_name' && result[i] !== 'last_name' && result[i] !== 'full_name') {
                    personalizationError = true
                } else {
                    if (!personalizeOptions.includes(result[i])) {

                        personalizeOptions = [...personalizeOptions, result[i]];
                        ////console.log('personalize options after: ', personalizeOptions)
                    }
                    personalizationError = false

                }
            }
        }

        let invalidUrlError = !this.validURL(this.state.buttonLink)
        // //console.log('invalidUrlError: ', invalidUrlError)

        let buttonPropertiesError = false;
        if (this.state.buttonText !== '' || this.state.buttonLink !== '') {
            buttonPropertiesError = !(this.state.buttonText !== '' && this.state.buttonLink !== '');
        }

        ////console.log('personalize error: ', personalizationError);

        let messageType = ''
        if (this.state.messageType === 1) {
            messageType = 'Test'
        } else {
            if (this.state.messageContent) {
                messageType = messageType + 'Text'
            }
            if (this.state.imageFileUrl) {
                messageType = messageType !== '' ? messageType + '+Image' : messageType + 'Image'
            }
            if (this.state.buttonText) {
                messageType = messageType !== '' ? messageType + '+Button' : messageType + 'Button'
            }
        }

        // //console.log('messageType: ', messageType)
        let combinationError = messageType === 'Text+Image' || messageType === 'Image+Button' || messageType === 'Button' || messageType === 'Image'


        //checking for errors
        await this.setState({
            //balanceError: insufficientBalance,
            contactsError: zeroContacts,
            personalizeOptions: personalizeOptions,
            personalizationError: personalizationError, //emptyMessageError: emptyMessageError,
            buttonPropertiesError: buttonPropertiesError,
            invalidUrlError: invalidUrlError,
            combinationError: combinationError
        });
        this.props.updateUserFromServer()
        if (this.state.update === false) {


            let activatedCountries = this.state.selectedSourceFull[0].viber_client ? this.state.selectedSourceFull[0].viber_client.activated_countries : ''
            // //console.log('activatedCountries: ', activatedCountries);

            let activatedDialCodes = [];
            let i = 0
            for (i; i < activatedCountries.length; i++) {
                // //console.log('i: ', i)
                // //console.log('activatedCountryCode: ', activatedCountries[i])
                let newFullCountry = this.state.jsonCountries.find(country => {
                    try {
                        return country.code === activatedCountries[i]
                    } catch (e) {
                        return ''
                    }
                })

                // //console.log('newActivatedCountryFull: ', newFullCountry)
                // //console.log('newActivatedCountryFullDialCode: ', newFullCountry.dial_code)

                activatedDialCodes.push(newFullCountry.dial_code)
            }

            ////console.log('activatedDialCodes: ', activatedDialCodes)


            let noErrors = ''
            if (this.state.selectedRecipient === 'Add Manually') {
                noErrors = this.state.estimateError === false
                    //&& this.state.emptyMessageError === false
                    //&& this.state.balanceError === false
                    && this.state.contactsError === false && this.state.personalizationError === false && this.state.contactsCount !== '' && this.state.invalidUrlError === false && this.state.buttonPropertiesError === false && this.state.improperPhones.length === 0 && this.state.combinationError === false
                //&& this.state.excludedContacts.length === 0


            } else {
                noErrors = this.state.estimateError === false
                    //&& this.state.emptyMessageError === false
                    //&& this.state.balanceError === false
                    && this.state.contactsError === false && this.state.personalizationError === false && this.state.invalidUrlError === false && this.state.buttonPropertiesError === false && this.state.contactsCount !== '' && this.state.combinationError === false
                //&& this.state.excludedContacts.length === 0

            }

            ////console.log('noErrors: ', noErrors);

            if (noErrors) {
                await this.setState({
                    loading: true, disabled: false
                })
                let userId = getCurrentUserId()
                let selectedSource = this.props.selectedSource;
                let data = '';
                let selectedTagIds = this.state.selectedTagIds

                // console.log('selectedTag')
                this.handleMessageUpdate(this.state.messageContent)
                if (this.state.selectedRecipient === 'Add Manually') {
                    // //console.log('entered add manually data')
                    data = {
                        "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                        "message_type": messageType,
                        "message_way": "twoway",
                        "button_caption": this.state.buttonText,
                        "button_url": this.state.buttonLink,
                        "image_url": this.state.imageFileUrl,
                        "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                        "message_html": this.state.messageHTML,//html for rerun purposes
                        "from": this.state.alphanumericId,
                        "provider": "tyntec",
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": 0,//use tags or not for sending
                        "tag_ids": [],//list of tag ids (existing tags client previously created)
                        "manual_contacts": 1,//use manually pasted contacts (phone numbers)
                        "phones": this.state.numbersArray,//send as an array of phones
                        "country_codes": activatedDialCodes,//which country codes to include in sending-sends only to contacts who match this criteria
                        "country_isos": activatedCountries,
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize

                    }
                } else if (this.state.selectedRecipient === 'All Contacts') {
                    // //console.log('entered all contacts data')
                    data = {

                        "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                        "message_type": messageType,
                        "message_way": "twoway",
                        "button_caption": this.state.buttonText,
                        "button_url": this.state.buttonLink,
                        "image_url": this.state.imageFileUrl,
                        "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                        "message_html": this.state.messageHTML,//html for rerun purposes

                        "from": this.state.alphanumericId,
                        "provider": "tyntec",
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "tag_segmentation": 0,//use tags or not for sending
                        "tag_ids": [],//list of tag ids (existing tags client previously created)
                        "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                        "phones": [],//send as an array of phones
                        "country_codes": activatedDialCodes,//which country codes to include in sending-sends only to contacts who match this criteria
                        "country_isos": activatedCountries,
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize

                    }
                } else {
                    // //console.log('entered use segments data')

                    // //console.log('segments data - activatedCountries: ', activatedCountries);
                    // //console.log('segments data - activatedDialCodes: ', activatedDialCodes);
                    // //console.log('this.state.selectedCountries: ', this.state.selectedCountries)
                    // //console.log('this.state.selectedDialCodes: ', this.state.selectedDialCodes)

                    let countriesArray = []
                    if (this.state.selectedCountries.length === 0) {
                        ////console.log('selected countries state empty')
                        countriesArray = activatedCountries
                    } else {
                        ////console.log('selected countries state not empty')
                        let i = 0;
                        for (i; i < this.state.selectedCountries.length; i++) {
                            // //console.log('i: ', i);
                            // //console.log('selected country: ', this.state.selectedCountries[i]);
                            countriesArray.push(this.state.selectedCountries[i].code);
                        }
                    }

                    // //console.log('countriesArray: ', countriesArray)

                    let dialCodesArray = []

                    if (this.state.selectedDialCodes.length === 0) {
                        // //console.log('selected dial codes state empty')
                        dialCodesArray = activatedDialCodes
                    } else {
                        // //console.log('selected dial codes state not empty')

                        dialCodesArray = this.state.selectedDialCodes
                    }

                    // //console.log('dialCodesArray: ', dialCodesArray)

                    data = {
                        "message_purpose": this.state.messageType === 0 ? 'promotion' : 'transaction',
                        "message_type": messageType,
                        "tag_segmentation": this.state.selectedTags.length > 0 ? 1 : 0,//use tags or not for sending
                        "tag_ids": selectedTagIds,//list of tag ids (existing tags client previously created)
                        "message_way": "twoway",
                        "button_caption": this.state.buttonText,
                        "button_url": this.state.buttonLink,
                        "image_url": this.state.imageFileUrl,
                        "message": this.state.messageContent,//to calculate estimate based on message length-number of characters
                        "message_html": this.state.messageHTML,//html for rerun purposes
                        "from": this.state.alphanumericId,
                        "provider": "tyntec",
                        "model_type": "all",//fixed to “all” currently
                        "model_gender": "all",//fixed to “all” currently
                        "manual_contacts": 0,//use manually pasted contacts (phone numbers)
                        "phones": [],//send as an array of phones
                        "country_isos": countriesArray,   //which country codes to include in sending-sends only to contacts who match this criteria
                        "country_codes": dialCodesArray, //which country dial codes to include in sending-sends only to contacts who match this criteria
                        "personalize_parameters": this.state.personalizeParameters,
                        "personalize": this.state.personalize

                    }
                }

                try {
                    // console.log('send viber data: ', data)
                    // console.log('send viber call: ', '/api/user/' + userId + '/project/' + selectedSource + '/viber_tyntec_message')

                    let callType = type === 'send' ? '/viber_tyntec_message' : '/viber_log_sending'
                    let viberResponse =

                        await http.post('/api/user/' + userId + '/project/' + selectedSource + callType, data, {
                            headers: {
                                authorization: authService.getJwt()
                            }
                        })
                    // console.log('viberResponse: ', viberResponse)
                    if (viberResponse.data.message) {
                        this.setState({
                            loading: false, disabled: false, update: true, topUpBalance: true
                        })
                    } else {

                        //console.log('viberResponse: ', viberResponse);
                        ////console.log('data.free_messages_remaining: ', viberResponse.data.free_messages_remaining)
                        let freeMessagesRemaining = viberResponse.data.error ? this.state.freeMessages : viberResponse.data.free_messages_remaining
                        ////console.log('free messages remaining after sms: ', freeMessagesRemaining)
                        //console.log('viber sent - new balance remaining: ', viberResponse.data.viber_credit_remaining)

                        let availableWorkspaceCredit = viberResponse.data.project_balance_initial
                        let newWorkspaceBalance = viberResponse.data.workspace_credits_remaining

                        await this.setState({
                            loading: false,
                            disabled: false,
                            freeMessages: freeMessagesRemaining,
                            update: true,
                            viberSentModalActive: true,
                            excludedContacts: 0,
                            balance: Number(viberResponse.data.viber_credit_remaining).toFixed(2),
                            availableCredit: Number(viberResponse.data.initial_credit_remaining).toFixed(2),
                            newBalance: viberResponse.data.viber_credit_remaining,
                            availableWorkspaceCredit,
                            newWorkspaceBalance
                        })

                        this.props.updateUserFromServer()
                        toastr.success('Your Viber message has been successfully sent!')
                    }
                } catch (e) {

                    ////console.log('send message error: ', e)

                    toastr.error('Error Code #12030: Something went wrong... Please try again.')
                    this.setState({
                        loading: false, disabled: false
                    })
                }
            } else {
                this.setState({
                    loading: false, disabled: false, checkErrors: true
                })
            }
        } else {
            toastr.error('Error Code #12031: Please update estimated cost before starting campaign!')

        }
    }

    updateButtonText = (e) => {

        // //console.log('button text: ', e.target.value)
        this.setState({
            update: true, buttonText: e.target.value, buttonTextCharacters: e.target.value.length
        })
    }

    multiMenuItem = (item, {
        modifiers, handleClick
    }) => {
        if (this.state.selectedTags.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    query=''
                    shouldDismissPopover={true}

                />)
        } else {
            return (<MenuItem
                className='multiselect-menu-item'
                icon='small-tick'
                active={modifiers.active}
                key={item.id}
                label=''
                text={item.tag}
                onClick={handleClick}
                shouldDismissPopover={true}
            />)
        }
    };

    countryMenuItem = (item, {
        modifiers, handleClick
    }) => {
        if (this.state.selectedCountries.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.name}
                    label=''
                    text={item.name + ' ' + '(' + item.dial_code + ')' + ' ' + item.flag}
                    onClick={handleClick}
                    query=''
                    shouldDismissPopover={true}

                />)
        } else {
            return (<MenuItem
                className='multiselect-menu-item'
                icon='small-tick'
                active={modifiers.active}
                key={item.name}
                label=''
                text={item.name + ' ' + '(' + item.dial_code + ')' + ' ' + item.flag}
                onClick={handleClick}
                shouldDismissPopover={true}
            />)
        }
    };


    tagSelect = async (item) => {

        let selectedTagIds = [];
        ////console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;


        ////console.log('selected tags ids:', selectedTagIds);
        if (selectedTags.includes(item) === false) {

            selectedTags.push(item);
            await this.setState({selectedTags: selectedTags});
        } else {
            const newTags = await selectedTags.filter(t => t !== item);
            await this.setState({selectedTags: newTags})
        }

        this.state.selectedTags.map(tag => {
            selectedTagIds = [...selectedTagIds, tag.id]
        });
        this.getCostEstimate();

    };

    triggerUpsellModal = () => {
        // //console.log('upsellModalOpen')
        this.setState({
            upgradeModalActive: true,
            upgradeModalTitle: 'Personalization is not available on your current plan.',
            upgradeModalContent: `<p>Check out the plans and features below and choose one that suits your needs.<br>
                Our team is available from the chat if you need any assistance.</p>`,
        })
    }
    runCampaignCheck = (type) => {

        if (this.state?.selectedSourceFull[0]?.use_custom_plan && this.state?.selectedSourceFull[0]?.custom_plan?.additional_features) {
            // console.log('has custom plan')
            // console.log('this.state.selectedSourceFull[0]?.custom_plan.additional_features: ', this.state.selectedSourceFull[0].custom_plan.additional_features)
            if (this.state.selectedSourceFull[0].custom_plan.additional_features.tags_segmentation === 0 && this.state.selectedRecipient === 'Use Segments') {

                this.openUpgradeModal()
            } else {
                this.startCampaign(type)
            }
        } else {
            if (this.state?.selectedSourceFull[0]?.plan) {
                // console.log('doesnt have custom plan')
                // console.log('this.state.selectedSourceFull[0]?.plan.additional_features: ', this.state.selectedSourceFull[0].plan.additional_features)

                if (this.state?.selectedSourceFull[0]?.plan?.additional_features.tags_segmentation === 0 && this.state.selectedRecipient === 'Use Segments') {

                    // console.log('openUpgradeModal')
                    this.openUpgradeModal()
                } else {

                    this.startCampaign(type)
                }
            }
        }
    }


    countrySelect = async (item) => {
        ////console.log('selected country: ', item);
        let selectedCountries = this.state.selectedCountries;

        let selectedDialCodes = this.state.selectedDialCodes;
        ////console.log('selected tags ids:', selectedTagIds);
        if (selectedCountries.includes(item) === false) {
            selectedDialCodes.push(item.dial_code);
            selectedCountries.push(item);
            await this.setState({selectedCountries, selectedDialCodes});
        } else {
            let newCountries = await selectedCountries.filter(t => t !== item);
            let newPhones = await selectedDialCodes.filter(p => p.dial_code !== item.dial_code);
            await this.setState({selectedCountries: newCountries, selectedDialCodes: newPhones})
        }

        this.getCostEstimate();
    };

    filterTags = (item) => {

        ////console.log('filter item:', item);

        return this.props.tags.filter((t) => {
            return t.tag.toLowerCase().includes(item.toLowerCase());
        });
    };

    filterCountries = (item) => {

        ////console.log(' country filter item:', item);

        return this.state.jsonCountries.filter((c) => {
            try {
                return c.name.toLowerCase().includes(item.toLowerCase());
            } catch (e) {
                return null
            }
        });
    };

    tagRender = (item) => {


        // //console.log('tag render item:', item);
        // //console.log('')
        return (<Tag key={item.id}>{item.tag}</Tag>)
        // //console.log('tag render end');
    };

    countryRender = (item) => {

        ////console.log('flags :', this.state.flags[code]);
        //sets country code to lowercase

        return (<Tag key={item.name}>

            <span style={{marginRight: 8}}>{item.flag}</span>
            {item.dial_code}
        </Tag>)
    }
    updateMessageLifetime = (e) => {
        this.setState({
            messageLifetime: e
        })
    }
    handleButtonUrl = async (buttonLink) => {
        let n = buttonLink.startsWith('http');

        if (n === false) {
            buttonLink = 'http://' + buttonLink
        }

        await this.setState({
            update: true, buttonLink, initialButtonLink: ''
        })
        this.calculateMarkupScreenHeight()
    }

    handleTagRemove = async (item) => {

        let selectedTagIds = [];
        ////console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;


        // //console.log('selected tags:', selectedTags);
        // //console.log('item', item);
        // //console.log('itemId:', item.key);

        const newTags = await selectedTags.filter(t => t.tag !== item.props.children);

        newTags.map(tag => {
            selectedTagIds = [...selectedTagIds, tag.id]
        });

        ////console.log('newTags: ', newTags);
        ////console.log('selectedTagIds -  remove: ', selectedTagIds);

        await this.setState({selectedTags: newTags});
        this.getCostEstimate();

    };

    handleCountryRemove = async (item) => {

        ////console.log('country item: ', item);

        const selectedCountries = this.state.selectedCountries;
        const selectedDialCodes = this.state.selectedDialCodes;

        ////console.log('selectedCountries :', selectedCountries)
        const newCountries = await selectedCountries.filter(c => c.name !== item.key);
        const newPhones = await selectedDialCodes.filter(p => p.dial_code !== item.dial_code)
        ////console.log('newCountries :', newCountries)
        await this.setState({selectedCountries: newCountries, selectedDialCodes: newPhones})
        this.getCostEstimate();

    };

    senderRender = (item, {modifiers, handleClick}) => {
        return (<MenuItem
            key={item.text}
            text={item.text}
            value={item.text}
            active={modifiers.active}
            shouldDismissPopover={true}
            onClick={handleClick}
        />)
    };

    operatorRender = (item, {
        modifiers, handleClick
    }) => {

        return (

            <MenuItem
                key={item.value}
                text={item.value}
                value={item.value}
                active={modifiers.active}
                shouldDismissPopover={true}
                onClick={handleClick}
            />)
    };

    senderItemSelect = (item) => {
        this.setState({selectedSender: item.text})
    }

    operatorItemSelect = (item) => {
        this.setState({selectedOperator: item.text})
    }

    handleMessage = (message) => {
        this.setState({

            messageContent: message,
            characterCount: SmsCounter.count(message).length,
            messagesNumber: SmsCounter.count(message).messages,
            charsRemaining: SmsCounter.count(message).per_message
        });
    };

    handlePhoneNumbers = (numbers) => {

        let numbersArray = numbers.replace(/ /g, '').split(',');
        this.setState({
            listOfNumbers: numbers, numbersArray: numbersArray, update: true
        });

    };

    handleRecipient = async (e) => {
        ////console.log(e.target.textContent);
        let textContent = await e.target.textContent
        await this.setState({
            highlightCostEstimate: false, //balanceError: false,
            contactsError: false,
            selectedRecipient: textContent,
            error: '',
            attemptingMessages: '',
            remainingCredits: '',
            contactsCount: '',
            update: true,
            excludedContacts: [],
            excludedContactsCount: 0,
            excludedContactsCountryNames: []
        })
        if (textContent === 'All Contacts' || textContent === 'Use Segments') {
            await this.getCostEstimate()
        }
        //this.getCostEstimate();
    };

    handleWhen = async (e) => {
        await this.setState({selectedWhen: e.target.textContent})
    }
    getImageName = () => {
        return /[^/]*$/.exec(this.state.imageFileUrl)[0]
    }
    toggleEmoji = async () => {
        let x = document.querySelector('.emoji-mart');

        if (x.style.display === "none") {
            document.querySelector('#post-message-text').focus();
            x.style.display = "block";
            await this.setState({native: true})
        } else {
            x.style.display = "none";
            await this.setState({native: true})
        }
    };

    handleEmoji = (e) => {
        ////console.log('clicked:', e.native);

        document.querySelector('#post-message-text').value += e.native;
        let messageText = document.querySelector('#post-message-text').value;
        this.setState({characterCount: messageText.length, messageContent: messageText});
        document.querySelector('#post-message-text').focus();
        this.handleMessage(document.querySelector('#post-message-text').value)
    };
    getCursorPosition = () => {
        let textarea = document.getElementsByTagName("textarea")[0]
        // console.log('textarea: ', textarea)
        let cursorPosition = textarea.selectionStart
        //console.log('cursorPosition: ', cursorPosition)
        this.setState({
            cursorPosition
        })
    }

    render() {
        const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
        const isFirefox = typeof InstallTrigger !== 'undefined';

        let imageFileUrl = this.state.imageFileUrl
        let minimalEstimateCost
        let vatCountry = this.state.listOfEuAbbreviations.filter(country => country === this.state.country)
        ////console.log('vatCountry: ', vatCountry)
        if (vatCountry) {
            // //console.log('vatCountry length: ', vatCountry.length);
        }

        if (vatCountry.length > 0 && this.state.country !== '') {
            ////console.log('vat country length is not 0, it is: ', vatCountry.length)
            minimalEstimateCost = parseFloat(this.state.costEstimate * 1.2)
        } else {
            ////console.log('vat country length is 0')
            minimalEstimateCost = parseFloat(this.state.costEstimate)
        }

        ////console.log('minimalEstimateCost: ',minimalEstimateCost)
        // console.log('selectedSourceFull: ', this.state.selectedSourceFull)

        return (<React.Fragment>
            <h1 className='main-title'>Viber</h1>
            <p className="nav-back" onClick={() => this.props.history.push('/new')}><i
                className="fas fa-chevron-left"></i> New Campaign</p>
            <div className="">
                <div className="fb-message-wrapper sms-wrapper viber-wrapper">

                    <div className="full-row-label text-bold m-m-b all-caps campaign-panel-title">
                        New Viber Campaign
                    </div>
                    {this.state.selectedSourceFull ? this.state.selectedSourceFull[0] ? this.state.selectedSourceFull[0].viber_client !== null ? '' :
                        <Callout icon='warning-sign' className='viber-callout' intent={Intent.WARNING}>
                            Enable Viber Business Message channel in order to start a new campaign.<a
                            href="https://emitto.io/viber-new-sender-name/">Request access now.</a>

                        </Callout> : '' : ''

                    }
                    {this.state.selectedSourceFull[0] ? this.state.selectedSourceFull[0].viber_client ? this.state.cardSoonExpired ?

                        <Callout icon='warning-sign' className='viber-callout' intent={Intent.WARNING}>
                            Your payment method is expiring soon. <a href="/billing/payment-methods">Update
                            your Card</a> in order to maintain your
                            active Viber Business subscription.
                        </Callout> : '' : '' : ''

                    }
                    {/*{this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].default_billing_details === null ?*/}

                    {/*    <Callout icon='warning-sign' className='viber-callout' intent={Intent.WARNING}>*/}
                    {/*        In order to maintain your Viber Business subscription you must Add a Payment*/}
                    {/*        Method.*/}
                    {/*        <Link to='/billing/payment-methods'>*/}
                    {/*            <a href="#">Add a Payment Method</a>*/}
                    {/*        </Link>*/}
                    {/*    </Callout> : ''*/}

                    {/*}*/}

                    <div className="flex-row-wrapper">

                        <div className="half-width">
                            <p className="campaign-panel-subtitle">Message Details</p>
                            <div className="viber-select-container">

                                    <span className='label small-label'>Send From
                                        <Tooltip
                                            // interactionKind={PopoverInteractionKind.CLICK}

                                            className={Classes.TOOLTIP_INDICATOR}
                                            content='Your registered Viber brand name.'
                                            usePortal={false}
                                        >
                                            <span className="far fa-question-circle"></span>
                                        </Tooltip>
                                    </span>

                                <InputRegular
                                    id="1"
                                    label1=""
                                    label2=""
                                    placeholder=""
                                    type='text'
                                    disabled={true}
                                    onChange=''
                                    value={this.state.alphanumericId ? this.state.alphanumericId : 'No Alphanumeric Id'}
                                    required={true}
                                    fieldsCheckActive=''
                                    updateErrorsList=''
                                    errorMessage=''
                                />

                            </div>

                            {this.state.brandError === true ? <div className="input-notification-danger">
                                Brand name can only contain letters or numbers up to 11 characters.
                            </div> : ''}
                            <div className="viber-message-type">
                                <p className='m-m-t'>Message type</p>
                                <div
                                    //onClick={this.handleWhen}
                                    className='flex-direction-row when-to-send m-lg-b'
                                >

                                    <div
                                        className={this.state.messageType === 0 ? "when-selection active" : 'when-selection '}
                                        onClick={() => this.changeMessageType(0)}

                                    >
                                        Promotional

                                    </div>

                                    <div
                                        className={this.state.messageType === 1 ? "when-selection active" : 'when-selection'}
                                        onClick={() => this.changeMessageType(1)}
                                    >
                                        Transactional
                                    </div>
                                </div>
                            </div>

                            <CampaignsTextArea
                                triggerUpsellModal={this.triggerUpsellModal}
                                selectedRecipient={this.state.selectedRecipient}
                                updateCursorPosition={this.updateCursorPosition}
                                viber={true}
                                uniqueId='viber-message'
                                onUpdate={this.handleViberFallbackMessage}
                                label={'Message'}
                                placeholder={'Your SMS message goes here'}
                                height={120}
                                maxCharacters={1000}
                                infoCircleType={'question'}
                                infoCircleContent='Message'
                                showMessagesNumber={true}
                                personalize={true}
                                selectedSourceFull={this.state.selectedSourceFull[0]}
                                plan={this.state.sourcePlan}
                                selectedSource={this.state.selectedSource}
                                messageContent={this.state.messageContent}
                                cursorPosition={this.state.cursorPosition}
                                onClick={this.getCursorPosition}
                                sendButton={true}
                                sendButtonFunction={this.sendSMSMessage}
                                buttonLoading={this.state.loading}
                            />

                            {this.state.messageType === 0 ? <React.Fragment>
                                <div className="viber-dropzone-container">
                                            <span className='label small-label'>Image
                                                <Tooltip
                                                    // interactionKind={PopoverInteractionKind.CLICK}

                                                    className={Classes.TOOLTIP_INDICATOR}
                                                    content={<div className='viber-image-info-bubble'>
                                                        The maximum image size that you can use
                                                        in a Viber message is <span
                                                        className='text-bold'>1600x1200px</span>, up to
                                                        <span className='text-bold'> 2MB</span>.
                                                    </div>}
                                                    usePortal={false}
                                                >
                                                    <span className="far fa-question-circle"></span>
                                                </Tooltip>
                                            </span>{//if rerun has image

                                    imageFileUrl && this.state.rerunFinished ? <div className="success-container">
                                        <div className="image-container">
                                            {imageFileUrl === '' ? <span
                                                className='fa fa-spin fa-spinner'></span> : imageFileUrl.substr(imageFileUrl.length - 4) === '.pdf' ?
                                                <img src="/img/pdf.png" alt="pdf document"/> : <img src={imageFileUrl}
                                                                                                    alt={this.getImageName()}/>}
                                            <p>{this.getImageName()}</p>
                                        </div>
                                        <span onClick={this.removeViberImage}
                                              className="fas fa-times"></span>
                                    </div> : this.state.files.length > 0 ? this.handleUploadSuccess() : <FileUpload
                                        category={'viber_preview_image'}
                                        maxSizeMb={25}
                                        fileType='document'
                                        // disabled={this.props.documentationVerified}
                                        text={'Drag and drop file here (png, jpeg, jpg, pdf)'}
                                        buttonText={'Upload Image'}
                                        buttonType='blue'
                                        onUploadStart={this.onFileUploadStart}
                                        onUploadEnd={this.onFileUploadEnd}
                                        onUploadProgressChange={this.onUploadProgressChange}
                                        hideLoader={false}
                                        loaderSize={'large'}
                                    />
                                    // <Dropzone
                                    //     onDrop={this.onDrop}
                                    //     multiple={false}
                                    //     accept={['.png', '.jpeg', '.jpg', '.pdf']}
                                    //     //accept={'.png'}
                                    //     maxSize={10240000}
                                    //     onDragEnter={() => this.setState({dropZoneHovered: true})}
                                    //     onDragLeave={() => this.setState({dropZoneHovered: false})}
                                    //     onDropRejected={(e) => this.setState({
                                    //         dropRejectedData: e,
                                    //         files: []
                                    //     })}
                                    // >
                                    //     {({getRootProps, getInputProps}) => (
                                    //         <section className="viber-picture-container">
                                    //             <div {...getRootProps({className: this.state.dropZoneHovered ? 'dropzone hovered' : 'dropzone'})}>
                                    //                 <input {...getInputProps()} />
                                    //                 <p className='text-center'>Drag and drop file here
                                    //                     (png,
                                    //                     jpeg,
                                    //                     jpg, pdf)
                                    //                 </p>
                                    //                 <p className='m-s-t m-sm-b'>or</p>
                                    //                 <button className='btn-action'>
                                    //                     Upload Image
                                    //                 </button>
                                    //             </div>
                                    //         </section>
                                    //     )}
                                    // </Dropzone>
                                }
                                    {this.state.dropRejectedData.length > 0 ? this.handleUploadError() : ''}
                                </div>


                                <div className='space-between m-lg-t m-t-b'>
                                    <p className='text-bold trigger-options-title'>Action Button</p>
                                    <Switch checked={this.state.actionButton}
                                            label="Activate"
                                            onChange={this.triggerActionButton}
                                    />
                                </div>
                                {this.state.actionButton ? <React.Fragment>
                                    <div className="form-group m-k-b">
                                        <div className="space-between">
                                                        <span className='label'>Button text
                                                        </span>
                                            <span className='label'>
                                                            Characters: <span
                                                className='text-bold'>{this.state.buttonTextCharacters} /
                                                            19</span>
                                                        </span>
                                        </div>
                                        <input
                                            className='fb-sponsored-message-input'
                                            placeholder='Type button text here'
                                            maxLength={19}
                                            type="text"
                                            value={this.state.buttonText}
                                            onChange={(e) => this.updateButtonText(e)}/>
                                    </div>
                                    <div className="form-group ">

                                                    <span className='label'>Button URL
                                                    </span>
                                        {this.state.initialButtonLink ? <input
                                            className='fb-sponsored-message-input'
                                            placeholder="http://"
                                            type="text"
                                            value={this.state.initialButtonLink}
                                            onChange={(e) => this.handleButtonUrl(e.target.value)}
                                        /> : <input
                                            className='fb-sponsored-message-input'
                                            placeholder="http://"
                                            type="text"
                                            value={this.state.buttonLink}
                                            onChange={(e) => this.handleButtonUrl(e.target.value)}
                                        />}

                                    </div>
                                </React.Fragment> : ''

                                }


                                {/*{process.env.REACT_APP_ENVIRONMENT === 'DEV' ?*/}
                                {/*    <React.Fragment>*/}
                                {/*        <div className='space-between m-lg-t'>*/}
                                {/*            <p className='text-bold trigger-options-title'>Fallback SMS</p>*/}


                                {/*            <Switch checked={this.state.fallbackSMSActive}*/}
                                {/*                    label="Activate"*/}
                                {/*                    onChange={*/}
                                {/*                        this.triggerFallbackSms*/}
                                {/*                    }*/}

                                {/*            />*/}

                                {/*        </div>*/}
                                {/*        {this.state.fallbackSMSActive ?*/}
                                {/*            <React.Fragment>*/}
                                {/*                <ContentEditableTextarea*/}
                                {/*                    uniqueId='fallback-sms-message'*/}
                                {/*                    onUpdate={this.handleFallbackSMSUpdate}*/}
                                {/*                    label={'Message'}*/}
                                {/*                    placeholder={'Your Viber message goes here'}*/}
                                {/*                    height={120}*/}
                                {/*                    maxCharacters={''}*/}
                                {/*                    infoCircleType={'question'}*/}
                                {/*                    infoCircleContent='Message'*/}
                                {/*                    showMessagesNumber={true}*/}
                                {/*                    personalize={this.state.selectedRecipient !== 'Add Manually'}*/}
                                {/*                    triggerUpsellModal={this.triggerUpsellModal}*/}
                                {/*                    plan={this.state.sourcePlan}*/}
                                {/*                    selectedSource={this.state.selectedSource}*/}
                                {/*                    viber={false}*/}
                                {/*                    messageContent={this.state.fallbackSMSContent}*/}
                                {/*                    rerunCampaignData={this.state.rerunCampaignData}*/}
                                {/*                    html={this.state.fallbackSMSHTML}*/}
                                {/*                />*/}
                                {/*                <InputRegular*/}
                                {/*                    id="3"*/}
                                {/*                    label1="Lifetime of the message (hours)"*/}
                                {/*                    label2=""*/}
                                {/*                    placeholder="Number of hours"*/}
                                {/*                    type='number'*/}
                                {/*                    disabled={false}*/}
                                {/*                    onChange={this.updateMessageLifetime}*/}
                                {/*                    value={this.state.messageLifetime ? this.state.messageLifetime : ''}*/}
                                {/*                    required={true}*/}
                                {/*                    fieldsCheckActive=''*/}
                                {/*                    updateErrorsList=''*/}
                                {/*                    errorMessage=''*/}
                                {/*                    min={0}*/}

                                {/*                />*/}
                                {/*            </React.Fragment>*/}
                                {/*            :*/}
                                {/*            ''*/}
                                {/*        }*/}

                                {/*    </React.Fragment>*/}
                                {/*    :*/}
                                {/*    ''*/}
                                {/*}*/}

                            </React.Fragment> : ''}

                            <p className='m-lg-t trigger-options-title m-k-b'>Recipients</p>
                            <div className='flex-direction-row recipients m-m-b'>
                                <div onClick={this.handleRecipient}
                                     className={this.state.selectedRecipient === 'Add Manually' ? "recipient active" : 'recipient'}
                                >
                                    Add Manually
                                </div>
                                <div onClick={this.handleRecipient}
                                     className={this.state.selectedRecipient === 'All Contacts' ? "recipient active" : 'recipient'}>
                                    All Contacts
                                </div>
                                <div onClick={this.handleRecipient}
                                     className={this.state.selectedRecipient === 'Use Segments' ? "recipient active" : 'recipient'}
                                >
                                    Use Segments
                                </div>
                            </div>
                            <div className="recipient-section">
                                {this.state.selectedRecipient === 'Add Manually' ?
                                    <div className="form-group primary-text ">
                                        <p>Paste Numbers</p>
                                        <textarea id='message-numbers'
                                                  className={this.state.listOfNumbers !== '' ? 'post-message-text valid' : 'post-message-text'}
                                                  placeholder="Type or paste phone numbers here. Separated by comma (,). You can add up to 500 numbers. Example:. +108001234567"

                                                  onChange={(e) => {
                                                      this.handlePhoneNumbers(e.target.value)
                                                  }}
                                                  value={this.state.listOfNumbers}>

                                    </textarea>

                                    </div> : this.state.selectedRecipient === 'All Contacts' ? !this.state.update ?
                                        <Callout className='m-s-t'>
                                            {this.state.noContacts === false ? this.state.loading === true ?
                                                <React.Fragment>
                                                    <Spinner size={21}/>
                                                </React.Fragment> : <React.Fragment>


                                                    Messages will be sent
                                                    to {this.state.contactsCount + ' ' !== '' ? this.state.contactsCount + ' ' : 0 + ' '}
                                                    contacts in your data base.


                                                </React.Fragment> : <React.Fragment>
                                                You have <span className='text-bold'>0 </span> contacts in
                                                your data base. <Link
                                                to="/import-contacts">Import contacts</Link>
                                            </React.Fragment>}
                                        </Callout> : '' : <React.Fragment>
                                        {this.state.selectedSourceFull && this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].use_custom_plan && this.state.selectedSourceFull[0].custom_plan && this.state.selectedSourceFull[0].custom_plan.additional_features ? this.state.selectedSourceFull[0].custom_plan.additional_features.tags_segmentation === 0 ?
                                                <Callout
                                                    intent='primary'
                                                    icon='info-sign'
                                                >
                                                    <React.Fragment>
                                                        Segments are not available
                                                        on {this.state.selectedSourceFull[0].custom_plan.name} plan. <br></br>
                                                        To unlock segmentation<a
                                                        onClick={this.openUpgradeModal}
                                                        href="#">upgrade now.</a>
                                                    </React.Fragment>
                                                </Callout> : ''

                                            : this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].plan && this.state.selectedSourceFull[0].plan.additional_features && this.state.selectedSourceFull[0].plan.additional_features.tags_segmentation === 0 ?
                                                <Callout
                                                    intent='primary'
                                                    icon='info-sign'
                                                >
                                                    <React.Fragment>
                                                        Segments are not available
                                                        on {this.state.selectedSourceFull[0].plan.name} plan. <br></br>
                                                        To unlock segmentation<a
                                                        onClick={this.openUpgradeModal}
                                                        href="#">upgrade now.</a>
                                                    </React.Fragment>
                                                </Callout> : ''}
                                        <p className='m-m-t'>Send to contacts with these tags</p>
                                        <MultiSelect
                                            items={this.props.tags}
                                            itemRenderer={this.multiMenuItem}
                                            tagInputProps={{
                                                placeholder: 'Filter by tag', onRemove: this.handleTagRemove
                                            }}
                                            resetOnSelect={true}
                                            className='tag-multiselect countries-multiselect'
                                            onItemSelect={this.tagSelect}
                                            tagRenderer={this.tagRender}
                                            itemListPredicate={this.filterTags}
                                            selectedItems={this.state.selectedTags}
                                            fill={true}
                                            noResults={<MenuItem disabled={true} text="No results."/>}

                                        />
                                        <p>Send to specific country</p>
                                        <MultiSelect
                                            items={this.state.jsonCountries}
                                            itemRenderer={this.countryMenuItem}
                                            tagInputProps={{
                                                placeholder: 'Filter by country', onRemove: this.handleCountryRemove
                                            }}
                                            filterable={true}
                                            resetOnSelect={true}
                                            className='tag-multiselect'
                                            onItemSelect={this.countrySelect}
                                            tagRenderer={this.countryRender}
                                            itemListPredicate={this.filterCountries}
                                            selectedItems={this.state.selectedCountries}
                                            fill={true}
                                            noResults={<MenuItem disabled={true} text="No results."/>}
                                        />
                                        {this.state.noContacts === true ?


                                            <Callout
                                                className='m-m-t'
                                            >

                                                <React.Fragment>
                                                    You have <span className='text-bold'>0 </span> contacts
                                                    in
                                                    your data base. <Link
                                                    to="/import-contacts">Import contacts</Link>
                                                </React.Fragment>

                                            </Callout>

                                            : this.state.showContactsCount ? this.state.contactsCount !== 0 ? <Callout
                                                intent='success'
                                                className='m-m-t'
                                            >
                                                {this.state.loading === true ? <React.Fragment>
                                                    <Spinner size={21}/>
                                                </React.Fragment> : <React.Fragment>
                                                                        <span
                                                                            className='text-bold'>{this.state.contactsCount !== undefined ? this.state.contactsCount : this.state.attemptingMessages}</span> contacts
                                                    in your data base match this criteria.


                                                </React.Fragment>}
                                            </Callout> : <Callout
                                                className='m-m-t'
                                            >

                                                {this.state.loading === true ? <React.Fragment>
                                                    <Spinner size={21}/> </React.Fragment> : <React.Fragment>
                                                    There are no contacts in your data base
                                                    matching
                                                    this criteria.
                                                </React.Fragment>}
                                            </Callout> : ''}
                                    </React.Fragment>


                                }

                                {this.state.loading ?

                                    <span className='viber-spinner-container'>
                                            <Spinner size={75}/>
                                        </span>

                                    :

                                    this.state.update ? <Callout
                                            className={this.state.highlightCostEstimate ? 'estimate-cost-callout red-border' : 'estimate-cost-callout'}>


                                                <span className='flex-row justify-content-space'>

                                                    <div className='flex-row estimated-cost-container'>
                                                        Estimated Cost:
                                                    </div>

                                                    <span
                                                        onClick={this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].viber_client ? this.updateCostEstimate : function () {
                                                            return null
                                                        }}

                                                        className={this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].viber_client ? 'cost-estimate-value cost-free update' : 'cost-estimate-value cost-free update disabled'}
                                                    >
                                                        {this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].viber_client ?

                                                            'UPDATE'

                                                            : <Tooltip className='cursor-pointer'
                                                                       content="Your Viber Business Account is not activated."
                                                                       position={Position.BOTTOM}>
                                                                UPDATE
                                                            </Tooltip>

                                                        }
                                                    </span>
                                                </span>
                                        </Callout> : //UPDATED
                                        this.state.costEstimate === '0.0000' ? //FREE CASE
                                            <Callout className='estimate-cost-callout'>


                                                    <span className='flex-row justify-content-space'>

                                                        <div className='flex-row estimated-cost-container'>
                                                            Estimated Cost:
                                                        </div>
                                                        <span className='cost-estimate-value cost-free'>FREE</span>

                                                    </span>

                                            </Callout>

                                            :

                                            // NOT FREE CASE
                                            <React.Fragment>
                                                <Callout className='estimate-cost-callout viber-total-cost'>

                                                        <span className='flex-row justify-content-space'>

                                                            <div className='flex-row estimated-cost-container'>
                                                                Total Cost
                                                            </div>

                                                            <span
                                                                className='cost-estimate-value text-bold viber-cost-estimate-value text-bold'>


                                                                {this.state.costEstimate} credits

                                                            </span>

                                                        </span>
                                                    <hr/>
                                                    <span className='flex-row justify-content-space'>
                                                            <div>
                                                                Available Viber Credits
                                                            </div>
                                                            <div>
                                                                {Number(this.state.availableCredit).toFixed(2)} credits
                                                            </div>
                                                        </span>
                                                    {this.state.paymentMessage === ("Estimate larger than viber credits, will be deducted from workspace balance" && Number(this.state.availableWorkspaceCredit).toFixed(2) > 0) || (this.state.paymentMessage === "Estimate larger than both viber and workspace credits, top up enabled, will be deducted from workspace balance" && Number(this.state.availableWorkspaceCredit).toFixed(2) > 0) ?
                                                        <span className='flex-row justify-content-space'>
                                                                <div>
                                                                    Available Workspace Credits
                                                                </div>
                                                                <div>
                                                                    {Number(this.state.availableWorkspaceCredit).toFixed(2)}

                                                                </div>
                                                            </span> : ''}
                                                    {/*{this.state.topUpAmount !== '' ?*/}
                                                    {this.state.topUpAmount > 0 ?
                                                        <span className='flex-row justify-content-space'>
                                                                <div className='top-up-text'>
                                                                    Top-up Required
                                                                </div>
                                                                <div className='blue-text'>
                                                                    {this.state.topUpAmount !== '' && this.state.topUpAmount > 0 ? this.state.vatPercent !== 0 ?
                                                                            <React.Fragment>
                                                                                <div className='display-flex flex-column'>
                                                                                    <div>
                                                                                        {Number(Number(this.state.topUpAmount) + Number((this.state.topUpAmount / 100) * this.state.vatPercent)).toFixed(2) + 'credits'}

                                                                                        <span className='vat-included'>(VAT
                                                                                included:
                                                                                ${Number((this.state.topUpAmount / 100) * this.state.vatPercent).toFixed(2)})</span>
                                                                                    </div>
                                                                                    <div
                                                                                        className='align-right'>(${this.state.topUpAmountBalance.toFixed(2)})
                                                                                    </div>
                                                                                </div>
                                                                            </React.Fragment> :
                                                                            <div className='display-flex flex-column'>
                                                                                <div>
                                                                                    {Number(this.state.topUpAmount).toFixed(2) + ' credits'}
                                                                                </div>
                                                                                <div
                                                                                    className='align-right'>(${this.state.topUpAmountBalance.toFixed(2)})
                                                                                </div>
                                                                            </div>

                                                                        : '0.00 credits'}
                                                                        </div>
                                                                        </span> : ''}
                                                    {/*    : ''*/}
                                                    {/*}*/}
                                                </Callout>
                                                {/*{minimalEstimateCost < 0.5 && parseFloat(this.state.costEstimate) > 0 && this.state.update === false ?*/}
                                                {/*    <p className='text-right minimal-charge'>*/}
                                                {/*        *Minimal charge is $0.5 due to Stripe Policy.*/}
                                                {/*    </p>*/}
                                                {/*    :*/}
                                                {/*    ''*/}
                                                {/*}*/}
                                                {this.state.topUpDisclaimer ?
                                                    <p className='text-right minimal-charge top-up-disclaimer'>
                                                        Minimal top-up amount is $ 15.00
                                                    </p> : ''}
                                                <div className='new-balance-viber-container'>
                                                    <div
                                                        className={this.state.paymentMessage === "Estimate larger than viber credits, will be deducted from workspace balance" || (this.state.paymentMessage === "Estimate larger than both viber and workspace credits, top up enabled, will be deducted from workspace balance"
                                                            //    && Number(this.state.availableWorkspaceCredit).toFixed(2) > 0
                                                        )

                                                            ? 'new-balance-viber border-bottom display-flex justify-content-space' : 'new-balance-viber display-flex justify-content-space'

                                                        }>
                                                            <span>
                                                                Remaining Viber Credit
                                                            </span>
                                                        <span>
                                                                {Number(this.state.newBalance).toFixed(2)} credits
                                                            </span>
                                                    </div>
                                                    {this.state.paymentMessage === "Estimate larger than viber credits, will be deducted from workspace balance" || (this.state.paymentMessage === "Estimate larger than both viber and workspace credits, top up enabled, will be deducted from workspace balance"
                                                        //    && Number(this.state.availableWorkspaceCredit).toFixed(2) > 0
                                                    )

                                                        ? <div
                                                            className='new-balance-workspace display-flex justify-content-space'>
                                                                    <span>
                                                                        Remaining Workspace Balance
                                                                    </span>
                                                            <span>
                                                                        {Number(this.state.newWorkspaceBalance).toFixed(2)} credits
                                                                    </span>
                                                        </div> : ''}
                                                </div>

                                                {this.state.topUpBalance ?
                                                    <Callout intent='danger' className='margin-top-20'>
                                                        You need to <Link to="/billing/balance">add credits
                                                        to
                                                        your workspace
                                                        balance</Link> -
                                                        No workspace balance set up
                                                    </Callout> : ''}
                                            </React.Fragment>}
                                {this.state.personalizationNotice ? <Callout
                                    intent='primary'
                                    icon='info-sign'
                                    className='margin-top-20'
                                >
                                    When using <span
                                    className='text-semi-bold'>personalization</span> the
                                    actual
                                    cost may vary
                                    depending on the content of personalization tags.
                                </Callout> : ''

                                }
                                {(this.state.contactsCount === 0 || (this.state.firstMount !== true && this.state.contactsCount === '')) ?
                                    <Callout
                                        className='m-m-t'
                                        intent='primary'
                                        icon='info-sign'
                                    >
                                        Need more contacts for your campaigns? <a href="/contacts">Upload
                                        here!
                                    </a>
                                    </Callout> : ''}


                            </div>

                            <p className='trigger-options-title'>When to send</p>
                            <div
                                //onClick={this.handleWhen}
                                className='flex-direction-row when-to-send'
                            >
                                <Tooltip content="Coming Soon!" position={Position.BOTTOM}>
                                    <div
                                        className={this.state.selectedWhen === 'Schedule' ? "when-selection active" : 'when-selection disabled'}>

                                        Schedule

                                    </div>
                                </Tooltip>
                                <div
                                    className={this.state.selectedWhen === 'Immediately' ? "when-selection active" : 'when-selection'}>
                                    Immediately
                                </div>
                            </div>

                            <div className="sms-errors m-s-t ">
                                {this.state.checkErrors ? < Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >
                                    Please check the errors before clicking update.

                                </Callout> : ''}
                                {this.state.emptyMessageError ? <Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >Message text can't be empty!
                                    <span className='close-error'></span>
                                </Callout> : ''}
                                {this.state.contactsError ? <Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >You have <span className='text-bold'>0</span> contacts that match
                                    the
                                    selected criteria. There’s no-one to send the campaign to.
                                    <span className='close-error'></span>
                                </Callout> : ''}
                                {this.state.estimateError ? <Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >
                                    <div className='messages-callout-info'>
                                        <p className='text-bold'>Not enough remaining credits</p>
                                        Attempting to
                                        send: <span>{this.state.attemptingMessages}</span>
                                        <br/>
                                        Remaining
                                        credits: <span>{this.state.remainingCredits}</span>
                                        <a className='d-block' href="/sms">Upgrade to Pro Plan</a>
                                    </div>
                                </Callout> : ''}

                                {/*{this.state.emptyMessageError ?*/}
                                {/*    <Callout*/}
                                {/*        intent={"danger"}*/}
                                {/*        icon={'warning-sign'}*/}
                                {/*    >*/}
                                {/*        <div className='messages-callout-info'>*/}
                                {/*            <p>Your message can't be empty!</p>*/}
                                {/*        </div>*/}
                                {/*    </Callout>*/}
                                {/*    :*/}
                                {/*    ''*/}
                                {/*}*/}

                                {this.state.combinationError ? <Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >
                                    <div className='messages-callout-info'>
                                        <p>
                                            Viber allows you to send Promotional messages in the
                                            following
                                            forms:
                                            <ul>
                                                <li>Text only</li>
                                                <li>Text + Button combination</li>
                                                <li>Text + Image + Button combination</li>
                                            </ul>
                                            Create any combination from above and try sending your
                                            campaign
                                            again.
                                        </p>
                                    </div>
                                </Callout> : ''}
                                {this.state.buttonPropertiesError ? <Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >
                                    <div className='messages-callout-info'>
                                        <p>
                                            If you're including button, both "Button text" and
                                            "Button URL"
                                            must
                                            be populated!
                                        </p>
                                    </div>
                                </Callout> : ''}

                                {this.state.improperPhones.length > 0 && this.state.improperPhones[0] !== null ?
                                    <Callout
                                        intent={"danger"}
                                        icon={'warning-sign'}
                                    >
                                        Improper phone numbers:
                                        {this.state.improperPhones.map(improperNumber => <div>
                                            {improperNumber}
                                        </div>)}

                                        <span className='close-error'></span>
                                    </Callout> : ''}
                                {this.state.excludedContacts.length > 0 && this.state.excludedContacts[0] !== null ? this.state.selectedRecipient === 'Add Manually' ?
                                    <Callout
                                        intent={"warning"}
                                        icon={'warning-sign'}
                                        className={'orange-callout'}
                                    >
                                        We detected several contacts from non-activated countries
                                        for your Viber
                                        Business Account.
                                        <br/>
                                        Your Viber message won’t be sent
                                        to <span
                                        className='text-bold'>{this.state.excludedContactsCount}</span>
                                        {this.state.excludedContactsCount > 1 ? ' numbers.' : ' number.'}
                                        <span className='close-error'></span>
                                    </Callout> : <Callout
                                        intent={"warning"}
                                        icon={'warning-sign'}
                                        className={'orange-callout'}
                                    >
                                        We detected several contacts from non-activated countries
                                        for your Viber
                                        Business Account:
                                        <div>
                                            {this.state.excludedContacts.map((excludedContact, index) => <span
                                                key={this.state.excludedContactsCountryNames[index]}
                                                className='margin-top-10 margin-bottom-10 d-inline-b'>
                                                                    {this.state.excludedContactsCountryNames[index]}

                                                {index < this.state.excludedContacts.length - 1 ? <span
                                                    className='margin-right-5'>,</span> : ''}
                                                                </span>)

                                            }
                                        </div>
                                        {/*<span className='text-bold'>Your Viber message won't be sent*/}
                                        {/*    to {this.state.excludedContactsCount} {this.state.excludedContactsCount > 1 ? 'numbers' : 'number'}!</span>*/}

                                        Your Viber message won't be sent to <span
                                        className='text-bold'>{this.state.excludedContactsCount}</span>
                                        {this.state.excludedContactsCount > 1 ? ' numbers.' : ' number.'}

                                        <span className='close-error'></span>


                                    </Callout> : ''}
                                {this.state.personalizationError ? <Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >
                                    It seems like you're using an invalid personalisation markups.
                                    Please
                                    check
                                    your personalisation parameters for possible typo and use only
                                    values
                                    from
                                    "Personalize" menu.
                                    <span className='close-error'></span>
                                </Callout> : ''}

                                {this.state.invalidUrlError ? <Callout
                                    intent={"danger"}
                                    icon={'warning-sign'}
                                >
                                    Looks like you're using an invalid Button URL.
                                    Please check it and use valid URL.
                                    <span className='close-error'></span>
                                </Callout> : ''}

                            </div>
                            <div className="sms-buttons m-t-t">

                                <div className="flex-direction-row space-between">
                                    <Link to="/new">
                                        <button
                                            className="btn-lite dist-platf-button"

                                        >
                                            Cancel
                                        </button>
                                    </Link>
                                    <div
                                        className='display-flex'
                                        //onClick={this.state.sourcePlan === 'free'}
                                    >
                                        {process.env.REACT_APP_ENVIRONMENT === 'DEV' ? <button
                                            className="btn-action dist-platf-button margin-right-10"
                                            disabled={this.state.loading ? true : ''}
                                            onClick={() => this.runCampaignCheck('log')}>
                                            Test Log
                                            {this.state.loading ? <i className='fa fa-spin fa-spinner'></i> : ""}
                                        </button> : ''}
                                        <button
                                            className="btn-action dist-platf-button"
                                            disabled={this.state.loading ? true : ''}
                                            onClick={() => this.runCampaignCheck('send')}>
                                            Start Campaign
                                            {this.state.loading ? <i className='fa fa-spin fa-spinner'></i> : ""}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="half-width">
                            <p className='campaign-panel-subtitle'>Preview</p>
                            <div className="message-preview viber-message-preview">
                                <div className="phone-markup viber-phone-markup">
                                    <div className="screen-markup viber-screen-markup">
                                        <div className="sender-markup">
                                            {this.state.alphanumericId !== '' ? this.state.alphanumericId : ''}
                                        </div>
                                        {this.state.messageContent || this.state.files.length > 0 || this.state.buttonText !== '' ?
                                            <React.Fragment>
                                                <img className="brand-markup"
                                                     src={this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].viber_client && this.state.selectedSourceFull[0].viber_client.brand_photo ? this.state.selectedSourceFull[0].viber_client.brand_photo : '/img/viber-profile-img.png'}
                                                     alt='viber profile image'/>
                                                <div
                                                    className={this.state.actionButton && this.state.buttonText || this.state.buttonLink ? this.state.viberMessageMarkupHeight > 374 ? 'message-markup sms-message-markup viber-message-markup round-bottom overflow-y' : 'message-markup sms-message-markup viber-message-markup round-bottom' : this.state.viberMessageMarkupHeight > 374 ? 'sms-message-markup message-markup viber-message-markup overflow-y' : 'sms-message-markup message-markup viber-message-markup'}>
                                                    {this.state.messageContent !== '' ? <span>
                                                         {this.state.messageContent}
                                    </span> : ''}
                                                    {this.state.files.length > 0 || (this.state.rerunFinished && imageFileUrl) ?

                                                        imageFileUrl ? imageFileUrl.substr(imageFileUrl.length - 4) === '.pdf' ?
                                                                <div className='pdf-markup-container'>
                                                                    <img src="/img/pdf-black.png"
                                                                         alt="download PDF"/>
                                                                    <span>{/[^/]*$/.exec(imageFileUrl)[0]}</span>
                                                                </div> : <img src={imageFileUrl}
                                                                              alt="viber-preview-message"/> :

                                                            <div className='viber-spinner-container'>
                                                                <i className='fa fa-spin fa-spinner'></i>
                                                            </div> : ''}
                                                    {this.state.actionButton && this.state.buttonText || this.state.buttonLink ?
                                                        <div className='viber-button-message-container'>
                                                            <button className="viber-message-button">
                                                                {this.state.buttonText}
                                                            </button>
                                                        </div> :

                                                        ''}
                                                </div>
                                            </React.Fragment> : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ViberSentModal
                showModal={this.state.viberSentModalActive}
                handleClose={() => this.setState({viberSentModalActive: false})}
                width={500}
                maxWidth={500}
                history={this.props.history}
                costEstimate={this.state.costEstimate}
                contacts={this.state.contactsCount}
                country={this.state.country}
                newBalance={this.state.newBalance}
                topUpDisclaimer={this.state.topUpDisclaimer}
                availableCredit={this.state.availableCredit}
                topUpAmount={this.state.topUpAmount}
                availableWorkspaceCredits={this.state.availableWorkspaceCredit}
                newWorkspaceBalance={this.state.newWorkspaceBalance}
                paymentMessage={this.state.paymentMessage}
                vatPercent={this.state.vatPercent}
            />
            <PaymentMethodMissingModal
                showModal={this.state.paymentMethodModal}
                handleClose={() => this.setState({paymentMethodModal: false})}
                maxWidth={500}
                history={this.props.history}
            />
            <PaymentMethodExpiredModal
                showModal={this.state.paymentMethodExpiredModal}
                handleClose={() => this.setState({paymentMethodExpiredModal: false})}
                maxWidth={500}
                history={this.props.history}
            />
            <UpsellModalTailwind
                showModal={this.state.upgradeModalActive}
                handleClose={() => this.setState({upgradeModalActive: false})}
                maxWidth={null}
                history={this.props.history}
                title={this.state.upgradeModalTitle}
                content={this.state.upgradeModalContent}
                buttonLink={this.state.modalButtonLink}
                buttonLabel={this.state.modalButtonLabel}
                plan={this.state.sourcePlan}
                user={this.props.user}
                updateUserFromServer={this.props.updateUserFromServer}
                selectedSource={this.state.selectedSource}
            />

        </React.Fragment>)
    }
}

export default Viber;